(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[340],{

/***/ 54497:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const SHOPPING_CART = 'M17.4173 17.4087C17.9065 17.4087 18.3237 17.5889 18.6691 17.9495C19.0144 18.3101 19.187 18.7356 19.187 19.226C19.187 19.7163 19.0144 20.1346 18.6691 20.4808C18.3237 20.8269 17.9065 21 17.4173 21C16.9281 21 16.5036 20.8269 16.1439 20.4808C15.7842 20.1346 15.6043 19.7163 15.6043 19.226C15.6043 18.7356 15.7842 18.3101 16.1439 17.9495C16.5036 17.5889 16.9281 17.4087 17.4173 17.4087ZM3 3H5.95683L6.79856 4.77404H20.1151C20.3597 4.77404 20.5683 4.86418 20.741 5.04447C20.9137 5.22476 21 5.44471 21 5.70433C21 5.86298 20.9568 6 20.8705 6.11538L17.6763 11.9567C17.518 12.2308 17.2986 12.4543 17.018 12.6274C16.7374 12.8005 16.4317 12.887 16.1007 12.887H9.41007L8.61151 14.3582L8.56835 14.488C8.56835 14.5457 8.58993 14.5962 8.63309 14.6394C8.67626 14.6827 8.72662 14.7043 8.78417 14.7043H19.187V16.5216H8.39568C7.90647 16.5216 7.48921 16.3413 7.14388 15.9808C6.79856 15.6202 6.6259 15.1947 6.6259 14.7043C6.6259 14.4303 6.69784 14.149 6.84173 13.8606L8.05036 11.6106L4.81295 4.77404H3V3ZM8.39568 17.4087C8.88489 17.4087 9.30935 17.5889 9.66906 17.9495C10.0288 18.3101 10.2086 18.7356 10.2086 19.226C10.2086 19.7163 10.0288 20.1346 9.66906 20.4808C9.30935 20.8269 8.88489 21 8.39568 21C7.90647 21 7.48921 20.8269 7.14388 20.4808C6.79856 20.1346 6.6259 19.7163 6.6259 19.226C6.6259 18.7356 6.79856 18.3101 7.14388 17.9495C7.48921 17.5889 7.90647 17.4087 8.39568 17.4087Z';
const IconShoppingCart = lib.variant('IconShoppingCart', icon.Icon, {
    path: SHOPPING_CART,
});

exports.w = IconShoppingCart;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 38264:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const TRASH = 'M8.58008 2H15.4441L16.5714 3.10257H20V5.3077H4V3.10257H7.42857L8.58008 2ZM18.8891 6.41027H5.14286V19.3538C5.14286 20.8153 6.32759 22 7.78902 22H16.243C17.7044 22 18.8891 20.8153 18.8891 19.3538V6.41027Z';
const IconTrash = lib.variant('IconTrash', icon.Icon, {
    path: TRASH,
});

exports.I = IconTrash;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 13066:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ campaign_group)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(85732);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  border-color: ",
        ";\n  border-style: solid;\n  border-width: 1px;\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CampaignListItem = (0,styled_components_browser_esm["default"])(list_variants.GridColumn).withConfig({
    displayName: "CampaignListItem",
    componentId: "sc-0-0"
})(_templateObject(), base/* colors.borderLightGray */.O9.borderLightGray, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RowWithWrap = (0,styled_components_browser_esm["default"])(list_variants.GridRow).withConfig({
    displayName: "RowWithWrap",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/index.js








var CampaignGroup = function(param) {
    var campaigns = param.campaigns, title = param.title, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!(campaigns === null || campaigns === void 0 ? void 0 : campaigns.length)) return null;
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
        className: className
    }, title && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, title), /*#__PURE__*/ react.createElement(RowWithWrap, null, campaigns.map(function(campaign) {
        return /*#__PURE__*/ react.createElement(CampaignListItem, {
            key: campaign.id
        }, /*#__PURE__*/ react.createElement(variants.H4Text, null, campaign.title.short), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            container: "p"
        }, campaign.description.short), /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
            campaign: campaign,
            linkContent: t("campaigns", "link.visit-campaign"),
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                    nextPage: campaign.web_uri.responsive
                });
            }
        }));
    })));
};
var arrayOf = (prop_types_default()).arrayOf, number = (prop_types_default()).number, shape = (prop_types_default()).shape, string = (prop_types_default()).string;
CampaignGroup.propTypes = {
    title: string,
    campaigns: arrayOf(shape({
        id: number.isRequired,
        slug: string,
        title: shape({
            short: string,
            long: string
        }),
        description: shape({
            short: string,
            long: string
        })
    }).isRequired),
    className: string
};
CampaignGroup.defaultProps = {
    title: undefined,
    className: undefined
};
/* harmony default export */ var campaign_group = (CampaignGroup);


/***/ }),

/***/ 85732:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ components_link)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/areas/campaign/components/link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TitleMediumTextLink = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "TitleMediumTextLink",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/campaign/components/link/index.js





var CampaignLink = function(props) {
    var renderMode = (0,react.useContext)(app_context/* AppContext */.Il).renderMode;
    var campaign = props.campaign, linkContent = props.linkContent, onClick = props.onClick;
    if (!linkContent) {
        return null;
    }
    if (renderMode === "native") {
        return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
            container: "a",
            containerProps: {
                href: campaign.web_uri.mobile,
                "data-test": props["data-test"],
                onClick: onClick
            }
        }, linkContent);
    }
    return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: "".concat(campaign.web_uri.responsive).concat(props.queryString || ""),
            "data-test": props["data-test"],
            onClick: onClick
        }
    }, linkContent);
};
var shape = (prop_types_default()).shape, string = (prop_types_default()).string, node = (prop_types_default()).node, func = (prop_types_default()).func;
CampaignLink.propTypes = {
    linkContent: node,
    queryString: string,
    campaign: shape({
        title: shape({
            short: string
        }),
        description: shape({
            short: string
        }),
        web_uri: shape({
            desktop: string,
            mobile: string
        })
    }).isRequired,
    className: string,
    "data-test": string,
    onClick: func
};
CampaignLink.defaultProps = {
    linkContent: "",
    className: null,
    queryString: null,
    "data-test": undefined,
    onClick: undefined
};
/* harmony default export */ var components_link = (CampaignLink);


/***/ }),

/***/ 57832:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ FlipClock)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var FlipClock = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "flip-clock";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | flip-clock */ 831).then(__webpack_require__.bind(__webpack_require__, 57275));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(57275);
        }
        return eval("require.resolve")("./flip-clock");
    }
});


/***/ }),

/***/ 59267:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ breadcrumb)
});

// UNUSED EXPORTS: CampaignBreadcrumb

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(88999);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/campaign/components/breadcrumb/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
;// CONCATENATED MODULE: ./src/areas/campaign/components/breadcrumb/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var CampaignBreadcrumb = function(props) {
    var campaign = props.campaign;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var base = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.campaign.base;
    });
    var getBreadcrumbPath = function() {
        var path = _toConsumableArray(base ? [
            {
                id: "campaigns",
                name: t("campaigns", "themes.breadcrumb"),
                pathName: base
            }
        ] : []);
        if (campaign) {
            if (base) {
                path.push({
                    id: "".concat(campaign.id),
                    name: campaign.name || "",
                    pathName: "".concat(base, "/").concat(campaign.slug)
                });
            }
            if (props.article) {
                path.push({
                    id: "".concat(props.article.id),
                    name: props.article.title,
                    pathName: props.article.pathName
                });
            }
        }
        return path;
    };
    var paths = getBreadcrumbPath();
    return /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: paths.map(function(param, index) {
            var name = param.name, pathName = param.pathName;
            return {
                href: paths.length - 1 !== index ? pathName : undefined,
                title: name
            };
        })
    }));
};
/* harmony default export */ var breadcrumb = (CampaignBreadcrumb);


/***/ }),

/***/ 42905:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ themes)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/campaign/themes-query.graphql
var themes_query_graphql = __webpack_require__(98553);
var themes_query_graphql_default = /*#__PURE__*/__webpack_require__.n(themes_query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/campaign/queries/useThemesPageQuery.ts


function useThemesPageQuery() {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (themes_query_graphql_default()),
        routeName: "themes"
    });
}

// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: 80px;\n  height: 80px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ColumnWithGutter = (0,styled_components_browser_esm["default"])(variants.Column).withConfig({
    displayName: "ColumnWithGutter",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CampaignGraphic = styled_components_browser_esm["default"].img.withConfig({
    displayName: "CampaignGraphic",
    componentId: "sc-0-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-header/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: block;\n    padding: ",
        " 0;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  padding: ",
        " ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    .legacy & {\n      width: 65%;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n    min-height: 0;\n    width: 100%;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    padding: 0 20px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 5;\n  min-height: 164px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n    & img {\n      max-width: 65px;\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-align: center;\n  & img {\n    max-width: 150px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-align: left;\n  color: #000;\n  & strong {\n    font-weight: inherit;\n    color: #d00;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n    .legacy & {\n      padding-right: 30px;\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n    padding-left: 20px;\n    & h1 {\n      font-size: ",
        ";\n    }\n    & p {\n      font-weight: ",
        ";\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  min-width: 0;\n  padding-left: 30px;\n  flex-grow: 1;\n\n  & h1 {\n    font-weight: normal;\n    font-size: ",
        ";\n  }\n\n  & p {\n    color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: nowrap;\n    min-width: 100%;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 1;\n  margin-bottom: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n    min-width: 100%;\n    width: 100%;\n    padding-left: 0;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  min-width: 200px;\n  width: 200px;\n  padding-left: 30px;\n  margin-bottom: ",
        ";\n  &:empty {\n    display: none;\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-1"
})(_templateObject4(), base/* media.largeUp */.BC.largeUp(_templateObject2()), base/* media.mediumDown */.BC.mediumDown(_templateObject3()));
var Logo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(_templateObject6(), base/* media.mediumDown */.BC.mediumDown(_templateObject5()));
var Title = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "Title",
    componentId: "sc-0-3"
})(_templateObject7());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-4"
})(_templateObject10(), (0,base/* remCalc */.vR)(22), function(props) {
    return props.theme.text.secondary;
}, base/* media.largeUp */.BC.largeUp(_templateObject8()), base/* media.mediumDown */.BC.mediumDown(_templateObject9(), (0,base/* remCalc */.vR)(18), (0,base/* remCalc */.vR)(13)));
var LogoAndText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LogoAndText",
    componentId: "sc-0-5"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject11()));
var PeakIndex = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PeakIndex",
    componentId: "sc-0-6"
})(_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject13()));

// EXTERNAL MODULE: ./src/areas/campaign/components/breadcrumb/index.tsx + 1 modules
var breadcrumb = __webpack_require__(59267);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(85732);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/list-item.js








var DAILY_DEALS_ID = 4;
var formatDates = function(campaign, translationCode, timeZone) {
    var start = new Date(parseInt(campaign.start, 10));
    var end = new Date(parseInt(campaign.end, 10));
    var locale = translationCode.replace("_", "-").toLowerCase();
    var localeOptions = {
        month: "long",
        day: "numeric",
        timeZone: timeZone
    };
    var startDate = start.toLocaleString(locale, localeOptions);
    var endDate = end.toLocaleString(locale, localeOptions);
    return startDate === endDate ? startDate : "".concat(startDate, " - ").concat(endDate);
};
var ThemeListItem = function(param) {
    var campaign = param.campaign, translation = param.translation, timezone = param.timezone;
    return campaign ? /*#__PURE__*/ react.createElement(variants.Row, {
        gap: 1,
        style: {
            flexWrap: "nowrap"
        }
    }, /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
        campaign: campaign,
        linkContent: /*#__PURE__*/ react.createElement(CampaignGraphic, {
            src: campaign.media.images.featured,
            alt: campaign.title.short
        }),
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                nextPage: campaign.web_uri.responsive
            });
        }
    }), /*#__PURE__*/ react.createElement(variants.Column, null, /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
        campaign: campaign,
        linkContent: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, campaign.title.short), /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, {
            container: "p"
        }, campaign.description.short)),
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                nextPage: campaign.web_uri.responsive
            });
        }
    }), campaign.id !== DAILY_DEALS_ID && /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, {
        container: "p"
    }, formatDates(campaign, translation, timezone)))) : null;
};
var shape = (prop_types_default()).shape, string = (prop_types_default()).string;
ThemeListItem.propTypes = {
    campaign: shape({
        title: shape({
            short: string
        }),
        description: shape({
            short: string
        })
    }).isRequired,
    translation: string.isRequired,
    timezone: string.isRequired
};
/* harmony default export */ var list_item = ((0,es/* connect */.$j)(function(state) {
    return {
        translation: state.areas.campaign.translation,
        timezone: state.areas.campaign.timezone
    };
})(ThemeListItem));

;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/component.tsx









var validCampaignTypes = [
    "OFFER"
];
var Themes = function(param) {
    var campaigns = param.campaigns;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var _type, _type1;
    var getCampaigns = function(ongoing) {
        return campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
            return ongoing ? (campaign === null || campaign === void 0 ? void 0 : campaign.state) === "ACTIVE" && validCampaignTypes.indexOf((_type = campaign.type) !== null && _type !== void 0 ? _type : "") >= 0 : (campaign === null || campaign === void 0 ? void 0 : campaign.state) === "UPCOMING" && validCampaignTypes.indexOf((_type1 = campaign.type) !== null && _type1 !== void 0 ? _type1 : "") >= 0;
        });
    };
    var ongoingCampaigns = getCampaigns(true);
    var upcomingCampaigns = getCampaigns(false);
    var imageHeaderSource = "".concat(market.cdn, "/g/campaigns/themes/campaigns-logo.png");
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(breadcrumb/* default */.Z, null), /*#__PURE__*/ react.createElement(Header, null, /*#__PURE__*/ react.createElement(Container, null, /*#__PURE__*/ react.createElement(Logo, null, /*#__PURE__*/ react.createElement("img", {
        src: imageHeaderSource,
        alt: t("campaigns", "themes.title")
    })), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(Title, null, t("campaigns", "themes.title")), /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, {
        container: "p"
    }, t("campaigns", "themes.description"))))), /*#__PURE__*/ react.createElement(ColumnWithGutter, null, /*#__PURE__*/ react.createElement(variants.Column, {
        gap: 4
    }, (ongoingCampaigns === null || ongoingCampaigns === void 0 ? void 0 : ongoingCampaigns.length) !== 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, {
        container: "h2"
    }, t("campaigns", "themes.ongoing-campaigns"))), /*#__PURE__*/ react.createElement(variants.Column, {
        gap: 2
    }, ongoingCampaigns === null || ongoingCampaigns === void 0 ? void 0 : ongoingCampaigns.map(function(campaign) {
        return campaign && /*#__PURE__*/ react.createElement(list_item, {
            key: campaign.name,
            campaign: campaign
        });
    }))), (upcomingCampaigns === null || upcomingCampaigns === void 0 ? void 0 : upcomingCampaigns.length) !== 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, {
        container: "h2"
    }, t("campaigns", "themes.upcoming-campaigns"))), /*#__PURE__*/ react.createElement(variants.Column, {
        gap: 2
    }, upcomingCampaigns.filter(function(campaign) {
        return (campaign === null || campaign === void 0 ? void 0 : campaign.type) === "OFFER";
    }).map(function(campaign) {
        return campaign && /*#__PURE__*/ react.createElement(list_item, {
            key: campaign.name,
            campaign: campaign
        });
    }))))));
};

;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/index.tsx





var ThemesLoader = function() {
    var ref = useThemesPageQuery(), isLoading = ref.isLoading, isSuccess = ref.isSuccess, data = ref.data;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data.campaigns ? /*#__PURE__*/ react.createElement(Themes, {
        campaigns: data.campaigns
    }) : null);
};
/* harmony default export */ var themes = (ThemesLoader);


/***/ }),

/***/ 24225:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ useDealsQuery)
/* harmony export */ });
/* harmony import */ var _deals_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38794);
/* harmony import */ var _deals_graphql__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_deals_graphql__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_hooks_use_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27019);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function useDealsQuery(variables) {
    // deals page only show available but SearchV3 return all
    var availability = {
        key: "availability",
        value: "AVAILABLE"
    };
    return (0,src_hooks_use_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .useGqlQuery */ .n)({
        query: (_deals_graphql__WEBPACK_IMPORTED_MODULE_0___default()),
        variables: _objectSpreadProps(_objectSpread({}, variables), {
            filters: variables.filters.concat(availability)
        }),
        queryKey: [
            "deals-page"
        ]
    });
}


/***/ }),

/***/ 96674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gh": () => (/* binding */ FilterContainer),
/* harmony export */   "QE": () => (/* binding */ Subtitle),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "YE": () => (/* binding */ Sidebar),
/* harmony export */   "ck": () => (/* binding */ Item),
/* harmony export */   "d2": () => (/* binding */ Article),
/* harmony export */   "h4": () => (/* binding */ Header),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "ll": () => (/* binding */ CardTitle),
/* harmony export */   "or": () => (/* binding */ Main)
/* harmony export */ });
/* unused harmony exports AVATAR_SIZE, Title, Info, MediaWrapper, Media, MediaImage, ContentType, Divider */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21541);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  a {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-columns: minmax(0, 1fr);\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-top: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &&,\n  > * {\n    font-size: ",
        ";\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0;\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      padding-right: ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        ";\n    flex-shrink: 0;\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: ",
        ";\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-auto-flow: row;\n  padding: ",
        " 0;\n  row-gap: ",
        ";\n  height: max-content;\n\n  h1 {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n      order: ",
        ";\n\n      &:not(:first-of-type) {\n        margin-top: ",
        ";\n      }\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    display: grid;\n    grid-auto-flow: row;\n    row-gap: ",
        ";\n    order: 2;\n    margin-top: ",
        ";\n\n    a:not([class]) {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n        text-decoration: underline;\n      }\n    }\n\n    ",
        ";\n\n    > h2,\n    > h3,\n    > *:last-child {\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  align-items: center;\n  justify-content: start;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 8px;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 16px;\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    margin: ",
        " 0;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  margin: ",
        " 0;\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow-x: auto;\n  padding: 2px;\n\n  > button {\n    flex-shrink: 0;\n    margin-bottom: ",
        ";\n\n    :not(:last-child) {\n      margin-right: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}



var AVATAR_SIZE = 32;
var CardTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "CardTitle",
    componentId: "sc-0-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject1()));
var Main = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].main.withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject3());
var Article = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].article.withConfig({
    displayName: "Article",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Item",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "Title",
    componentId: "sc-0-5"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var Sidebar = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].aside.withConfig({
    displayName: "Sidebar",
    componentId: "sc-0-6"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject8(), p.viewport === "desktop" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7())), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.viewport === "mobile" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9())));
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].header.withConfig({
    displayName: "Header",
    componentId: "sc-0-7"
})(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var _marginTop;
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-8"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), p.fontSize || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, p.rowGap || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, (_marginTop = p.marginTop) !== null && _marginTop !== void 0 ? _marginTop : src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.callToAction, p.theme.text.callToActionHover, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject14(), p.order || 2, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
});
var Info = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Info",
    componentId: "sc-0-9"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Subtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleMediumText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-10"
})(_templateObject17());
var MediaWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MediaWrapper",
    componentId: "sc-0-11"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), props.maxWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), props.maxWidth));
});
var Media = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-12"
})(_templateObject20());
var MediaImage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "MediaImage",
    componentId: "sc-0-13"
})(_templateObject22(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject21()));
var ContentType = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ContentType",
    componentId: "sc-0-14"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.secondary;
});
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].hr.withConfig({
    displayName: "Divider",
    componentId: "sc-0-15"
})(_templateObject25(), function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing300 */ .bK.measurements.spacing300, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
var FilterContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterContainer",
    componentId: "sc-0-16"
})(_templateObject26(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ campaign_banner_legacy)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaign-banner/campaign-banner-legacy/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n  padding: ",
        ";\n  background-position: center center;\n  background-size: cover;\n  color: white;\n  text-align: center;\n  flex-direction: column;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: ",
        ";\n    padding-right: calc(",
        " * 2);\n    border-right: 1px solid white;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: content-box;\n  flex: 0 0 auto;\n\n  padding: ",
        ";\n  padding-bottom: 0;\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 300px;\n    min-width: 200px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 200px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: calc(",
        " * 2);\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  max-width: 600px;\n  margin: 0 auto;\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  border: 1px solid currentColor;\n  border-radius: ",
        ";\n  display: inline-block;\n  font-weight: 600;\n  outline: none;\n  padding: 10px 20px;\n  transition: box-shadow 0.1s linear;\n\n  :hover,\n  :focus {\n    color: ",
        ";\n  }\n\n  :focus {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var basePadding = "20px";
var Banner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Banner",
    componentId: "sc-0-0"
})(_templateObject1(), basePadding, base/* media.mediumUp */.BC.mediumUp(_templateObject()));
var BadgeSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BadgeSection",
    componentId: "sc-0-1"
})(_templateObject3(), basePadding, base/* media.mediumUp */.BC.mediumUp(_templateObject2(), basePadding, basePadding));
var BadgeImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "BadgeImage",
    componentId: "sc-0-2"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject4()));
var MainSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MainSection",
    componentId: "sc-0-3"
})(_templateObject7(), basePadding, base/* media.mediumUp */.BC.mediumUp(_templateObject6(), basePadding));
var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Description",
    componentId: "sc-0-4"
})(_templateObject8(), basePadding);
var Button = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Button",
    componentId: "sc-0-5"
})(_templateObject9(), function(p) {
    return p.theme.colors.base0;
}, base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return p.theme.colors.base200;
});

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaign-banner/campaign-banner-legacy/index.tsx




var CampaignBannerLegacy = function(param) {
    var url = param.url, imageUrl = param.imageUrl, badgeUrl = param.badgeUrl, badgeAltText = param.badgeAltText, description = param.description, linkText = param.linkText;
    var onClick = function() {
        return (0,tracking/* trackInternalNavigationClick */.p)({
            nextPage: url,
            scope: tracking/* InternalNavigationScope.HERO_BANNER */.U.HERO_BANNER
        });
    };
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(Banner, {
        style: {
            backgroundImage: "url(".concat(imageUrl, ")")
        }
    }, badgeUrl && /*#__PURE__*/ react.createElement(BadgeSection, null, /*#__PURE__*/ react.createElement(BadgeImage, {
        src: badgeUrl,
        alt: badgeAltText || ""
    })), /*#__PURE__*/ react.createElement(MainSection, null, /*#__PURE__*/ react.createElement(Description, null, description), url && /*#__PURE__*/ react.createElement(Button, {
        to: url,
        onClick: onClick
    }, linkText))));
};
/* harmony default export */ var campaign_banner_legacy = (CampaignBannerLegacy);


/***/ }),

/***/ 81491:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ campaign_banner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/areas/landing-page/components/campaign-banner/campaign-banner/utils.ts
var utils = __webpack_require__(29200);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/globals/helpers/campaign/campaign-ids.ts
var campaign_ids = __webpack_require__(26016);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaign-banner/campaign-banner/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: ",
        "px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: ",
        ";\n  max-width: ",
        ";\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-top: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n\n      ",
        " {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n\n      ",
        " {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: ",
        ";\n    border-radius: 8px;\n    padding: ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n  ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: ",
        "px;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(4, 1fr);\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(3, 1fr);\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: row;\n  grid-template-columns: repeat(6, 1fr);\n  gap: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var IMAGE_MAX_WIDTH = 560;
var LINK_WIDTH_DESKTOP = 120;
var LINK_WIDTH_MOBILE = 88;
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, LINK_WIDTH_DESKTOP, base/* media.smallOnly */.BC.smallOnly(_templateObject(), LINK_WIDTH_MOBILE));
var StyledCampaignBanner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledCampaignBanner",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumUp */.BC.mediumUp(_templateObject2(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300), props.$activeCampaign === campaign_ids/* CampaignEnum.BLACK_FRIDAY */.MC.BLACK_FRIDAY && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.colors.base900, StyledLink, props.theme.colors.base0), [
        campaign_ids/* CampaignEnum.CYBER_MONDAY */.MC.CYBER_MONDAY,
        campaign_ids/* CampaignEnum.CHRISTMAS_SALE */.MC.CHRISTMAS_SALE
    ].includes(props.$activeCampaign) && (0,styled_components_browser_esm.css)(_templateObject4(), props.theme.colors.maybeBlue100, StyledLink, props.theme.colors.base900));
});
var StyledBadgeImg = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledBadgeImg",
    componentId: "sc-0-2"
})(_templateObject6(), IMAGE_MAX_WIDTH);
var StyledLinksWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledLinksWrapper",
    componentId: "sc-0-3"
})(_templateObject9(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumOnly */.BC.mediumOnly(_templateObject7()), base/* media.smallOnly */.BC.smallOnly(_templateObject8()));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaign-banner/campaign-banner/index.tsx









var CampaignBanner = function(param) {
    var activeCampaign = param.activeCampaign, altText = param.altText, url = param.url;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,context/* useViewportContext */.Ak)(), isMobile = ref1.isMobile, isTablet = ref1.isTablet;
    if (!url) return null;
    var ref2 = (0,utils/* getBannerDetails */.X)(market, t, Boolean(isMobile), url), campaign = ref2[activeCampaign], categoryLinks = ref2.categoryLinks;
    var nbrOfVisibleCategoryLinks = isTablet ? 4 : 6;
    var onClick = function(nextPage) {
        return (0,tracking/* trackInternalNavigationClick */.p)({
            nextPage: nextPage,
            scope: tracking/* InternalNavigationScope.HERO_BANNER */.U.HERO_BANNER
        });
    };
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(StyledCampaignBanner, {
        $activeCampaign: activeCampaign
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: url,
        onClick: function() {
            return onClick(url);
        }
    }, /*#__PURE__*/ react.createElement(StyledBadgeImg, {
        src: campaign.badgeUrl,
        alt: altText || ""
    })), /*#__PURE__*/ react.createElement(StyledLinksWrapper, null, categoryLinks.slice(0, nbrOfVisibleCategoryLinks).map(function(category) {
        return /*#__PURE__*/ react.createElement(StyledLink, {
            to: category.link,
            key: category.name,
            onClick: function() {
                return onClick(category.link);
            }
        }, /*#__PURE__*/ react.createElement("img", {
            src: category.image,
            alt: ""
        }), /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, category.name));
    }))));
};
/* harmony default export */ var campaign_banner = (CampaignBanner);


/***/ }),

/***/ 29200:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ getBannerDetails),
/* harmony export */   "u": () => (/* binding */ supportedCampaignIds)
/* harmony export */ });
/* harmony import */ var src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26016);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var supportedCampaignIds = [
    src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignIdEnum.BLACK_FRIDAY_ID */ .pw.BLACK_FRIDAY_ID,
    src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignIdEnum.CHRISTMAS_SALE_ID */ .pw.CHRISTMAS_SALE_ID,
    src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignIdEnum.CYBER_MONDAY_ID */ .pw.CYBER_MONDAY_ID
];
var getBannerDetails = function(market, t, isMobile, url) {
    var _obj;
    return _obj = {}, _defineProperty(_obj, src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignEnum.BLACK_FRIDAY */ .MC.BLACK_FRIDAY, {
        badgeUrl: "".concat(market.cdn, "/g/campaigns/2/").concat(market.code, "/bf_banner_landing_page_big_").concat(isMobile ? "mobile" : "desktop", ".png")
    }), _defineProperty(_obj, src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignEnum.CHRISTMAS_SALE */ .MC.CHRISTMAS_SALE, {
        badgeUrl: "".concat(market.cdn, "/g/campaigns/3/").concat(market.code, "/cs_banner_landing_page_big_").concat(isMobile ? "mobile" : "desktop", ".png")
    }), _defineProperty(_obj, src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_0__/* .CampaignEnum.CYBER_MONDAY */ .MC.CYBER_MONDAY, {
        badgeUrl: "".concat(market.cdn, "/g/campaigns/6/").concat(market.code, "/cm_banner_landing_page_big_").concat(isMobile ? "mobile" : "desktop", ".png")
    }), _defineProperty(_obj, "categoryLinks", [
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-headphones"),
            link: "".concat(url, "?category=3004"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_headphones.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-smartphones"),
            link: "".concat(url, "?category=103"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_smartphones.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-tvs"),
            link: "".concat(url, "?category=107"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_tvs.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-shoes"),
            link: "".concat(url, "?category=1490"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_shoes.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-perfumes"),
            link: "".concat(url, "?category=965"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_perfumes.png")
        },
        {
            name: t("campaigns", "campaign.bf-banner-landing-page-category-kitchen"),
            link: "".concat(url, "?category=1671"),
            image: "".concat(market.cdn, "/g/campaigns/2/bf_banner_landing_page_big_category_kitchen.png")
        }
    ]), _obj;
};


/***/ }),

/***/ 56752:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": () => (/* binding */ ProductAlertForm)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/currency/market-settings.ts
var market_settings = __webpack_require__(87665);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(92191);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/trash/index.js
var trash = __webpack_require__(38264);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(19590);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/render-context/ctx-link.tsx



var CtxLink = /*#__PURE__*/ (0,react.memo)(function(props) {
    var renderMode = (0,app_context/* useAppContext */.bp)().renderMode;
    var legacyRenderMode = [
        "desktop",
        "mobile",
        "native"
    ].includes(renderMode);
    if (legacyRenderMode) {
        return /*#__PURE__*/ react.createElement("a", {
            onClick: props.onClick,
            href: props.to
        }, props.children);
    }
    return /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        onClick: props.onClick,
        to: props.to
    }, props.children);
});

// EXTERNAL MODULE: ./src/components/review-form/components/multi-radio/index.tsx
var multi_radio = __webpack_require__(22663);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
// EXTERNAL MODULE: ./src/hooks/use-account.ts + 1 modules
var use_account = __webpack_require__(53082);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/types.ts
var types = __webpack_require__(14236);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-form/email-hint-styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    margin: 0.5rem 0;\n\n    display: ",
        ";\n\n    a {\n      text-decoration: underline !important;\n      ",
        "\n    }\n\n    ",
        "\n\n    p {\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var EmailHint = styled_components_browser_esm["default"].div.attrs({
    "data-test": "EmailHint"
}).withConfig({
    displayName: "EmailHint",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.visible ? "block" : "none";
}, function(p) {
    return p.discreetLink && "color: ".concat(p.theme.colors.base500, ";");
}, function(p) {
    return p.error && "color: ".concat(p.theme.colors.negative700, ";");
});

// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-form/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    .pj-ui-text-input {\n      margin-right: 0;\n    }\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  .pj-ui-text-input {\n    margin-right: 1rem;\n    &--input {\n      height: 45px;\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: ",
        ";\n  align-items: center;\n  margin-top: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  .pj-ui-input {\n  margin-bottom: 1rem;\n  }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}







var EmailInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EmailInput",
    componentId: "sc-0-0"
})(_templateObject1(), base/* media.smallOnly */.BC.smallOnly(styles_templateObject()), function(p) {
    return p.error && "\n    .pj-ui-input--input {\n      border-color: ".concat(p.theme.colors.negative700, ";\n    }\n  ");
});
var RatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingWrapper",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var AlertForm = styled_components_browser_esm["default"].form.withConfig({
    displayName: "AlertForm",
    componentId: "sc-0-2"
})(_templateObject4(), base/* media.smallOnly */.BC.smallOnly(_templateObject3()));
var PriceBelowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceBelowWrapper",
    componentId: "sc-0-3"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var NumberInput = (0,styled_components_browser_esm["default"])(inputs/* NumberInput */.Y2).attrs({
    variant: "rounded"
}).withConfig({
    displayName: "NumberInput",
    componentId: "sc-0-4"
})(_templateObject6());
var TextInput = (0,styled_components_browser_esm["default"])(inputs/* TextInput */.oi).attrs({
    variant: "rounded"
}).withConfig({
    displayName: "TextInput",
    componentId: "sc-0-5"
})(_templateObject7());
var PriceStepWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceStepWrapper",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var INPUT_WIDTH = 77;
var PriceStepInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceStepInput",
    componentId: "sc-0-7"
})(_templateObject9(), INPUT_WIDTH, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ShopsFilterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShopsFilterWrapper",
    componentId: "sc-0-8"
})(_templateObject10(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShopPreferenceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShopPreferenceWrapper",
    componentId: "sc-0-9"
})(_templateObject11(), base/* layout.measurements.spacing125 */.bK.measurements.spacing125, base/* layout.measurements.spacing125 */.bK.measurements.spacing125);
var ShopSettingsLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ShopSettingsLink",
    componentId: "sc-0-10"
})(_templateObject12(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var ShopPreferenceDropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "ShopPreferenceDropdown",
    componentId: "sc-0-11"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CheckboxNotify = (0,styled_components_browser_esm["default"])(checkbox_variants/* Checkbox */.XZ).withConfig({
    displayName: "CheckboxNotify",
    componentId: "sc-0-12"
})(_templateObject14(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var RemoveButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "RemoveButton",
    componentId: "sc-0-13"
})(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SubmitButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SubmitButtonWrapper",
    componentId: "sc-0-14"
})(_templateObject16());
var CancelButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "CancelButton",
    componentId: "sc-0-15"
})(_templateObject17(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SaveAlertButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "SaveAlertButton",
    componentId: "sc-0-16"
})(_templateObject18());
var CurrencySymbol = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CurrencySymbol",
    componentId: "sc-0-17"
})(_templateObject19(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/components/dropdown-item/index.ts + 1 modules
var dropdown_item = __webpack_require__(28839);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-form/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}























var getDefaultPriceThreshold = function(regularPrice) {
    var minimumStepValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.1, numberOfDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return regularPrice ? (regularPrice - minimumStepValue).toFixed(numberOfDecimals) : "0";
};
var getDefaultPriceStep = function(regularPrice) {
    var minimumStepValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.1, numberOfDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var minDefaultPriceStep = minimumStepValue * 10;
    // Returns the largest value of 1% of regularPrice or minDefaultPriceStep
    return regularPrice ? Math.max(regularPrice * 0.01, minDefaultPriceStep).toFixed(numberOfDecimals) : String(minDefaultPriceStep);
};
var numberOfStoresAboveRating = function(prices, rating) {
    if (!prices) {
        return -1;
    }
    return prices.filter(function(price) {
        var ref, ref1;
        return Number(price === null || price === void 0 ? void 0 : (ref = price.store) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.rating) > rating;
    }).length;
};
var ProductAlertForm = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref, ref1, ref2;
    var productAlertFormData = props.productAlertFormData, onClose = props.onClose, onCreate = props.onCreate, privacyPolicyUri = props.privacyPolicyUri, error = props.error, _isEdit = props.isEdit, isEdit = _isEdit === void 0 ? true : _isEdit, shouldAutoFocus = props.shouldAutoFocus, disabled = props.disabled, _showRemoveButton = props.showRemoveButton, showRemoveButton = _showRemoveButton === void 0 ? true : _showRemoveButton;
    var ref3 = (0,app_context/* useAppContext */.bp)(), market = ref3.market, t = ref3.t;
    var product = productAlertFormData.product;
    var userProductAlerts = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var emailInput = (0,react.useRef)(null);
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var _code = market_settings/* MarketSettings */.G[market.code], minimumStepValue = _code.minimumStepValue, numberOfDecimals = _code.numberOfDecimals;
    var ref4 = _slicedToArray((0,react.useState)(new Set()), 2), errors = ref4[0], setErrors = ref4[1];
    var ref5 = _slicedToArray((0,react.useState)(""), 2), email = ref5[0], setEmail = ref5[1];
    var ref6 = _slicedToArray((0,react.useState)(false), 2), hasSubmitted = ref6[0], setHasSubmitted = ref6[1];
    var ref7 = _slicedToArray((0,react.useState)(((product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.storeGradeThreshold) || 0) / 2), 2), chosenStoreGradeThreshold = ref7[0], setChosenStoreGradeThreshold = ref7[1];
    var ref8 = _slicedToArray((0,react.useState)(function() {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.priceThreshold) ? String(product.alert.priceThreshold) : getDefaultPriceThreshold(product === null || product === void 0 ? void 0 : product.priceSummary.regular, minimumStepValue, numberOfDecimals);
    }), 2), priceThreshold = ref8[0], setPriceThreshold = ref8[1];
    var ref9 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : (ref1 = product.alert) === null || ref1 === void 0 ? void 0 : ref1.alertType) !== types/* AlertTypes.PRICE_DROPS */.d_.PRICE_DROPS), 2), onlyAlertIfInStock = ref9[0], setOnlyAlertIfInStock = ref9[1];
    var ref10 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : (ref2 = product.alert) === null || ref2 === void 0 ? void 0 : ref2.storePreference) || types/* ShopPreference.NONE */.lc.NONE), 2), shopPreference = ref10[0], setShopPreference = ref10[1];
    // Default to true
    var ref11 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : product.alert) ? !!product.alert.priceStep : true), 2), priceStepCheckbox = ref11[0], setPriceStepCheckbox = ref11[1];
    var ref12 = _slicedToArray((0,react.useState)(function() {
        var ref;
        if (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.priceStep) {
            return String(product.alert.priceStep);
        }
        return getDefaultPriceStep(product === null || product === void 0 ? void 0 : product.priceSummary.regular, minimumStepValue, numberOfDecimals);
    }), 2), priceStep = ref12[0], setPriceStep = ref12[1];
    (0,react.useEffect)(function() {
        if (emailInput.current && shouldAutoFocus) {
            emailInput.current.focus();
        }
        return function cleanup() {
            dispatch((0,actions_alert/* removeAlertError */.TI)(undefined));
        };
    }, [
        dispatch,
        shouldAutoFocus
    ]);
    var clearErrors = function() {
        return setErrors(new Set());
    };
    var addError = function(newError) {
        setErrors(function(prevErrors) {
            var draftErrors = new Set(prevErrors);
            return draftErrors.add(newError);
        });
    };
    var removeError = function(errorToRemove) {
        setErrors(function(prevErrors) {
            var draftErrors = new Set(prevErrors);
            draftErrors.delete(errorToRemove);
            return draftErrors;
        });
    };
    (0,react.useEffect)(function() {
        if (!error) {
            return;
        }
        switch(error){
            case types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID:
            case types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE:
                {
                    addError(error);
                    break;
                }
            default:
                {
                    addError(types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN);
                }
        }
    }, [
        error
    ]);
    var handlePriceThresholdChange = function(event) {
        setPriceThreshold(event.target.value);
        if (!event.target.value || Number(event.target.value) < 0) {
            addError(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW);
        } else {
            removeError(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW);
        }
    };
    var handlePriceStepChange = function(event) {
        setPriceStep(event.target.value);
    };
    var handleOnlyAlertIfInStockChange = function() {
        return setOnlyAlertIfInStock(function(state) {
            return !state;
        });
    };
    var handlePriceStepCheckboxChange = function() {
        return setPriceStepCheckbox(function(state) {
            return !state;
        });
    };
    var handleEmailChange = function(event) {
        /* The error state is duplicated, between Redux and local state. This is due
    to the fact that we are using sagas to make the create alert request.
    The problem, apart from duplication, is that the error messages outlive the
    form since they are stored in redux. So the error handling in this form
    needs to be improved/simplified. But for now the code below is required to
    fix the issue with the email error messages not disappearing even though the
    user corrects the email.
    */ if ((0,helpers/* isValidEmail */.v)(event.target.value)) {
            removeError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        } else if (hasSubmitted) {
            addError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        }
        dispatch((0,actions_alert/* removeAlertError */.TI)(undefined));
        removeError(types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE);
        setEmail(event.target.value);
    };
    var saveAlert = (0,react.useCallback)(function(event) {
        event.preventDefault();
        setHasSubmitted(true);
        var ref = form_serialize_default()(event.target, {
            hash: true
        }), _rating = ref.rating, rating = _rating === void 0 ? 0 : _rating;
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === (product === null || product === void 0 ? void 0 : product.id);
        });
        if (!product) {
            return;
        }
        clearErrors();
        if (!isAuthenticated && !(0,helpers/* isValidEmail */.v)(email)) {
            addError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
            if (shouldAutoFocus && emailInput.current) {
                emailInput.current.focus();
                emailInput.current.select();
            }
            return;
        }
        if (Number(priceThreshold) < 0 || Number(priceStep) < 0) {
            return;
        }
        var graphQLAlert = {
            type: onlyAlertIfInStock ? types/* AlertTypes.IN_STOCK_PRICE_DROPS */.d_.IN_STOCK_PRICE_DROPS : types/* AlertTypes.PRICE_DROPS */.d_.PRICE_DROPS,
            priceThreshold: Number(priceThreshold)
        };
        var priceStepValue = priceStepCheckbox ? Number(priceStep) : undefined;
        onCreate(_objectSpread({
            alertId: userAlert && userAlert.alertId,
            productId: product.id,
            email: !isAuthenticated ? email : undefined,
            priceStep: priceStepValue,
            storePreference: shopPreference === types/* ShopPreference.NONE */.lc.NONE ? undefined : shopPreference,
            storeGradeThreshold: rating ? Number(rating) * 2 : undefined
        }, graphQLAlert));
    }, [
        email,
        onCreate,
        onlyAlertIfInStock,
        priceStep,
        priceStepCheckbox,
        priceThreshold,
        shopPreference,
        product,
        shouldAutoFocus,
        userProductAlerts,
        isAuthenticated
    ]);
    var removeAlert = function() {
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === (product === null || product === void 0 ? void 0 : product.id);
        });
        if (!(userAlert === null || userAlert === void 0 ? void 0 : userAlert.alertId)) return;
        dispatch((0,actions_alert/* removeAlertRequest */.s$)(userAlert.alertId, product === null || product === void 0 ? void 0 : product.id));
        if (onClose) onClose();
    };
    var shopPreferenceOptions = [
        {
            name: t("alerts", "alerts.shop-preference-none"),
            value: types/* ShopPreference.NONE */.lc.NONE
        },
        {
            name: t("alerts", "alerts.shop-preference-exclude-disliked"),
            value: types/* ShopPreference.EXCLUDE_DISLIKED */.lc.EXCLUDE_DISLIKED
        },
        {
            name: t("alerts", "alerts.shop-preference-liked"),
            value: types/* ShopPreference.LIKED */.lc.LIKED
        }
    ];
    var marketCurrencySymbol = market_settings/* MarketSettings */.G[market.code].symbol;
    var renderTypeOptions = function() {
        var ref, ref1, ref2;
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(PriceBelowWrapper, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
            emphasis: text_variants.FontEmphasis.MEDIUM
        }, t("alerts", "type.price-below")), /*#__PURE__*/ react.createElement(NumberInput, {
            name: "priceThreshold",
            ariaLabel: t("alerts", "alert-form.price-limit"),
            warning: errors.has(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW),
            value: priceThreshold,
            onChange: handlePriceThresholdChange,
            step: minimumStepValue,
            max: (product === null || product === void 0 ? void 0 : product.priceSummary.regular) ? Number((product.priceSummary.regular - minimumStepValue).toFixed(numberOfDecimals)) : undefined,
            min: 0,
            "data-testid": "price-threshold-number-input"
        })), /*#__PURE__*/ react.createElement(PriceStepWrapper, null, /*#__PURE__*/ react.createElement(checkbox_variants/* CheckboxSwitch */.K_, {
            text: t("alerts", "alert-form.price-step-checkbox"),
            onChange: handlePriceStepCheckboxChange,
            checked: priceStepCheckbox
        }), /*#__PURE__*/ react.createElement(PriceStepInput, null, /*#__PURE__*/ react.createElement(NumberInput, {
            name: "priceStep",
            ariaLabel: t("alerts", "alert-form.price-interval"),
            "data-testid": "price-step-number-input",
            disabled: !priceStepCheckbox,
            warning: Number(priceStep) < 0,
            value: priceStep,
            onChange: handlePriceStepChange,
            step: minimumStepValue,
            max: (product === null || product === void 0 ? void 0 : product.priceSummary.regular) ? Number((product.priceSummary.regular - minimumStepValue).toFixed(numberOfDecimals)) : undefined,
            min: 0
        })), /*#__PURE__*/ react.createElement(CurrencySymbol, null, marketCurrencySymbol))), /*#__PURE__*/ react.createElement(CheckboxNotify, {
            name: "onlyAlertIfInStock",
            checked: onlyAlertIfInStock,
            text: t("alerts", "alert-form.only-notify-in-stock"),
            onChange: handleOnlyAlertIfInStockChange
        }), /*#__PURE__*/ react.createElement(ShopsFilterWrapper, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
            emphasis: text_variants.FontEmphasis.MEDIUM
        }, t("alerts", "alert-form.shops-with-higher-rating")), /*#__PURE__*/ react.createElement(RatingWrapper, null, /*#__PURE__*/ react.createElement(multi_radio/* default */.ZP, {
            currentValue: (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.storeGradeThreshold) ? product.alert.storeGradeThreshold / 2 : null,
            disabledOptions: [
                5
            ],
            name: "rating",
            onClick: function(e) {
                setChosenStoreGradeThreshold(Number(e.target.value));
            },
            options: [
                1,
                2,
                3,
                4,
                5
            ],
            optionValues: [
                t("reviews", "rating.terrible"),
                t("reviews", "rating.bad"),
                t("reviews", "rating.ok"),
                t("reviews", "rating.good"),
                t("reviews", "rating.excellent")
            ],
            required: true,
            size: "small",
            variant: multi_radio/* Variants.rate */.tr.rate
        }), /*#__PURE__*/ react.createElement("p", null, (product === null || product === void 0 ? void 0 : product.prices) ? t("alerts", "alert-form.n-stores", {
            n: numberOfStoresAboveRating(product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : ref1.nodes, chosenStoreGradeThreshold)
        }) : null)), isAuthenticated && /*#__PURE__*/ react.createElement(ShopPreferenceWrapper, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
            emphasis: text_variants.FontEmphasis.MEDIUM
        }, t("alerts", "alert-form.filter-shops")), /*#__PURE__*/ react.createElement(ShopPreferenceDropdown, {
            closeOnItemClick: true
        }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
            showActiveIcon: true,
            type: variants.ButtonType.TEXT,
            disabled: !isAuthenticated,
            containerProps: {
                "data-testid": "ShopPreferenceSelector"
            }
        }, (ref2 = shopPreferenceOptions.find(function(row) {
            return row.value === shopPreference;
        })) === null || ref2 === void 0 ? void 0 : ref2.name), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
            placement: ui/* Direction.Up */.Nm.Up
        }, shopPreferenceOptions.map(function(option) {
            return /*#__PURE__*/ react.createElement(dropdown_item/* DropdownItem */.h, {
                "data-test": "DropdownOption",
                containerProps: {
                    "data-testid": option.value
                },
                key: option.value,
                disabled: shopPreference === option.value,
                onClick: function() {
                    return setShopPreference(option.value);
                }
            }, option.name);
        }))), /*#__PURE__*/ react.createElement(ShopSettingsLink, {
            to: "/account/profile/shop-preference"
        }, t("alerts", "alert-form.shops-settings")))));
    };
    var login = (0,use_account/* useAccount */.m)().login;
    return /*#__PURE__*/ react.createElement(AlertForm, {
        method: "post",
        onSubmit: saveAlert,
        noValidate: true
    }, renderTypeOptions(), /*#__PURE__*/ react.createElement(EmailInput, {
        error: errors.has(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID)
    }, !isAuthenticated && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(TextInput, {
        type: "email",
        name: "email",
        inputRef: emailInput,
        defaultValue: email,
        onChange: handleEmailChange,
        placeholder: t("alerts", "alert-form.email-placeholder"),
        tabIndex: 0,
        autoFocus: shouldAutoFocus,
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(EmailHint, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.email-in-use-error"), "\xa0", /*#__PURE__*/ react.createElement(CtxLink, {
        to: "/login",
        onClick: function(e) {
            e.preventDefault();
            (0,data_layer/* pushEvent */.A)("login", {
                loggedIn: true
            });
            login();
        }
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.login-error"))), /*#__PURE__*/ react.createElement(EmailHint, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.invalid-email-error")), /*#__PURE__*/ react.createElement(EmailHint, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.unknown-error")), privacyPolicyUri && /*#__PURE__*/ react.createElement(EmailHint, {
        visible: true,
        discreetLink: true
    }, privacyPolicyUri.startsWith("http") ? /*#__PURE__*/ react.createElement("a", {
        href: privacyPolicyUri
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "alert.how-your-email-is-used")) : /*#__PURE__*/ react.createElement(CtxLink, {
        to: privacyPolicyUri
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "alert.how-your-email-is-used"))))), isEdit && showRemoveButton && /*#__PURE__*/ react.createElement(RemoveButton, {
        onClick: removeAlert
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(trash/* IconTrash */.I, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("product", "alert.delete-button"))), /*#__PURE__*/ react.createElement(SubmitButtonWrapper, null, isEdit && onClose && product && /*#__PURE__*/ react.createElement(CancelButton, {
        onClick: onClose
    }, t("alerts", "alert-form.cancel-button")), /*#__PURE__*/ react.createElement(SaveAlertButton, {
        disabled: disabled || errors.size > 0,
        containerProps: {
            "data-testid": "CreateAlertButton",
            "data-test": "CreateAlertButton"
        },
        htmlType: "submit",
        fullWidth: true
    }, t("alerts", "alert-form.create-button"))));
});


/***/ }),

/***/ 79821:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35632);


var OffersGrid = function(param) {
    var children = param.children, className = param.className, offers = param.offers, isExtraWide = param.isExtraWide, isOffers = param.isOffers;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGrid */ .u5, {
        "data-test": isOffers ? "OfferGrid" : "ProductGrid",
        className: className,
        isExtraWide: isExtraWide
    }, children, offers && react__WEBPACK_IMPORTED_MODULE_0__.Children.map(offers, function(child, index) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGridItem */ .EA, {
            "data-test": isOffers ? "OfferGridCard" : "ProductGridCard",
            style: {
                order: index
            }
        }, child);
    }));
};


/***/ }),

/***/ 35632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EA": () => (/* binding */ OffersGridItem),
/* harmony export */   "cq": () => (/* binding */ ITEMS),
/* harmony export */   "u5": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94141);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76323);
/* eslint-disable no-nested-ternary */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          grid-gap: ",
        "rem;\n          grid-template-columns: repeat(\n            auto-fill,\n            minmax(auto, calc(",
        " - ",
        "))\n          );\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {\n      display: grid;\n      flex: 1 0 auto;\n      list-style: none;\n\n      ",
        "\n      ",
        "\n    }\n\n    /* Fallback to flex if grid-template-columns is not supported */\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



// We need to cover ALL breakpoints here since we use '`${breakpoint}Only`'
// If we left out xxl for example, then >1600px would look very weird as it wouldn't be covered by any breakpoint
// (This only works because the smallest and largest breakpoints are open in their respective direction)
var ITEMS = {
    small: 2,
    medium: 3,
    large: 4,
    xlarge: 4,
    xxlarge: 4
};
var GAPS = {
    small: 0.5,
    medium: 1,
    large: 1,
    xlarge: 1,
    xxlarge: 1
};
// These are calculated for each render
var SIZES = {};
var GUTTERS = {};
/**
 * Certain experiments require a different grid layout, which is passed as props
 * Here we determine how many items to show depending on the passed props
 */ function getItemsForExperiments(param) {
    var isExtraWide = param.isExtraWide;
    if (isExtraWide) {
        return {
            large: 4,
            xlarge: 5,
            xxlarge: 6
        };
    }
    return {
        large: 4,
        xlarge: 4,
        xxlarge: 4
    };
}
var OffersGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    displayName: "OffersGrid",
    componentId: "sc-0-0"
})(function(props) {
    // We need to mutate the object here because src/areas/product-collection/components/products/layout-grid/layout-grid.tsx relies on the current layout configuration, and that depends on getItemsForExperiment
    // We don't want to implement the same logic twice, therefore we need to access this object from somewhere else
    Object.assign(ITEMS, getItemsForExperiments(props));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // I'm not really happy with the current solution, but if we dynamically change ITEMS.large etc. for each render, then we also need to recalculate (gutter) sizes for each render
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for(var _iterator = src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames */ .PS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bp = _step.value;
            SIZES[bp] = "".concat(100 / ITEMS[bp], "%");
            GUTTERS[bp] = "".concat(GAPS[bp] * (ITEMS[bp] - 1), "rem / ").concat(ITEMS[bp]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), /* This only works because smallOnly and xxlargeOnly have no boundaries in each unset direction i.e. everything larger than xxlarge is considered xxlarge */ null, src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames.map */ .PS.map(function(breakpoint) {
        return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC["".concat(breakpoint, "Only")](_templateObject(), GAPS[breakpoint], SIZES[breakpoint], GUTTERS[breakpoint]);
    }));
});
var OffersGridItem = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].li.withConfig({
    displayName: "OffersGridItem",
    componentId: "sc-0-1"
})(_templateObject2());


/***/ }),

/***/ 6079:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ deals_page)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/campaign/query.graphql
var query_graphql = __webpack_require__(19478);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/campaign/queries/useCampaignPageQuery.ts


function useCampaignPageQuery(variables, enabled) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "campaign",
        variables: variables,
        refetchOnReconnect: false,
        enabled: enabled
    });
}

// EXTERNAL MODULE: ./src/areas/campaign/queries/useDealsQuery.ts
var useDealsQuery = __webpack_require__(24225);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/deals-page/contexts/deals-context.tsx
var deals_context = __webpack_require__(50313);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/contexts/search-context.tsx + 1 modules
var search_context = __webpack_require__(37680);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/contexts/tracking-context.tsx
var tracking_context = __webpack_require__(83207);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/flip-clock/index.js
var flip_clock = __webpack_require__(57832);
// EXTERNAL MODULE: ./src/components/newsletter-signup/index.ts + 2 modules
var newsletter_signup = __webpack_require__(608);
// EXTERNAL MODULE: ./src/globals/helpers/campaign/campaign-ids.ts
var campaign_ids = __webpack_require__(26016);
// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(52923);
// EXTERNAL MODULE: ./src/components/campaign-deals/index.ts
var campaign_deals = __webpack_require__(87341);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/campaign/components/shop-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  flex: 0 0 auto;\n  font-weight: 600;\n  padding: 10px;\n  background: #f5f9fb;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 0 5px 0 ",
        ";\n  transition: box-shadow 0.1s linear;\n  &:hover {\n    box-shadow: 0 0 5px 0 ",
        ";\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n  &:focus {\n    box-shadow: 0 0 0 2px ",
        ";\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  flex: 0 0 auto;\n  padding: 15px;\n  margin: auto 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var StyledShopCard = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledShopCard",
    componentId: "sc-0-0"
})(_templateObject());
var CallToActionText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CallToActionText",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.text.callToAction;
});
var ShopButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ShopButton",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.base200;
}, function(p) {
    return p.theme.colors.base300;
}, CallToActionText, function(p) {
    return p.theme.text.callToActionHover;
}, function(p) {
    return p.theme.colors.positive500;
}, CallToActionText, function(p) {
    return p.theme.text.callToActionHover;
});
var LogoWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LogoWrapper",
    componentId: "sc-0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/areas/campaign/components/shop-card/index.tsx



// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function() {};
var ShopCard = function(param) {
    var id = param.id, name = param.name, width = param.width, height = param.height, logo = param.logo, _hasLogo = param.hasLogo, hasLogo = _hasLogo === void 0 ? false : _hasLogo, _featured = param.featured, featured = _featured === void 0 ? false : _featured, _onClick = param.onClick, onClick = _onClick === void 0 ? noop : _onClick, callToActionText = param.callToActionText;
    return /*#__PURE__*/ react.createElement(StyledShopCard, null, /*#__PURE__*/ react.createElement(ShopButton, {
        type: "button",
        onClick: onClick,
        style: {
            width: width,
            height: height
        }
    }, hasLogo && id ? /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: id,
        width: width
    }) : /*#__PURE__*/ react.createElement(LogoWrapper, null, logo && featured ? /*#__PURE__*/ react.createElement("img", {
        alt: name,
        src: logo
    }) : name), callToActionText && /*#__PURE__*/ react.createElement(CallToActionText, null, callToActionText)));
};

// EXTERNAL MODULE: ./src/components/flexible-grid/index.ts + 2 modules
var flexible_grid = __webpack_require__(25676);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-card/deals-card-context.tsx

var initialValue = {
    aggregatedRating: {
        score: 0,
        count: 0
    },
    bestOffer: {
        condition: "new",
        featured: false,
        memberPrice: undefined,
        offerLink: "",
        originalPrice: undefined,
        price: 0,
        priceExpires: undefined,
        shopOfferId: "",
        stockStatus: "in_stock",
        storeId: 0,
        storeName: "",
        membershipRequiresCompensation: false
    },
    categoryName: "",
    coreProperties: [],
    dealUpdateTime: "",
    handleCardOnClick: undefined,
    handleClickOut: undefined,
    imageSearchModels: [],
    logo: undefined,
    name: "",
    parentCategoryIds: [],
    previousPrice: undefined,
    previousPriceText: undefined,
    priceDrop: 0,
    productId: 0,
    productLink: "",
    promotionShopPrices: [],
    showDropdown: true,
    storeCount: 0
};
var DealsCardContext = /*#__PURE__*/ (0,react.createContext)(initialValue);
var useDealsCardContext = function() {
    return useContext(DealsCardContext);
};
var DealsCardContextContainer = function(props) {
    return /*#__PURE__*/ react.createElement(DealsCardContext.Provider, {
        value: initialValue
    }, props.children);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(72943);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(85066);
// EXTERNAL MODULE: ./src/components/number-pagination/index.tsx + 3 modules
var number_pagination = __webpack_require__(49192);
// EXTERNAL MODULE: ./src/components/placeholder/index.tsx + 1 modules
var placeholder = __webpack_require__(69221);
// EXTERNAL MODULE: ./src/components/products-header/index.tsx + 4 modules
var products_header = __webpack_require__(63536);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(40763);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-card/index.tsx
var DealsCard = function(_any) {
    return null;
};

// EXTERNAL MODULE: ./src/areas/campaign/actions/index.js
var actions = __webpack_require__(51932);
;// CONCATENATED MODULE: ./src/areas/campaign/query.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FIELDS = [
    "product.category.path.name",
    "product.category.name",
    "product.brand.name",
    "store.name"
];
var FILTER_TERM_MAP = {
    category: "product.category.path.id",
    brand: "product.brand.name.keyword",
    store: "store.name.keyword"
};
/* harmony default export */ function campaign_query() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _instance, _instance1;
    var terms = query ? query.trim().split(/\s/) : []; // Split up terms for a broader match
    return {
        bool: {
            minimum_should_match: terms.length,
            should: (_instance1 = (_instance = []).concat.apply(_instance, _toConsumableArray(terms.map(function(term) {
                return FIELDS.map(function(field) {
                    return {
                        match_phrase_prefix: _defineProperty({}, field, {
                            query: term
                        })
                    };
                });
            })))).concat.apply(_instance1, _toConsumableArray(terms.map(function(term) {
                return FIELDS.map(function(field) {
                    return {
                        match_phrase: _defineProperty({}, field, {
                            query: term,
                            boost: 3
                        })
                    };
                });
            }))).concat(terms.map(function(term) {
                return {
                    match_phrase_prefix: {
                        "product.name": {
                            slop: 10,
                            query: term,
                            boost: 2
                        }
                    }
                };
            })).concat(terms.map(function(term) {
                return {
                    match_phrase: {
                        "product.name": {
                            query: term,
                            boost: 3
                        }
                    }
                };
            })),
            must: Object.keys(filter).filter(function(term) {
                return filter[term].length > 0;
            }).map(function(term) {
                return {
                    bool: {
                        should: [].concat(filter[term].map(function(value) {
                            return {
                                term: _defineProperty({}, FILTER_TERM_MAP[term], value)
                            };
                        }))
                    }
                };
            })
        }
    };
};

;// CONCATENATED MODULE: ./src/areas/campaign/components/data/use-with-elastic.tsx
function use_with_elastic_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || use_with_elastic_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function use_with_elastic_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return use_with_elastic_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return use_with_elastic_arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var defaultResponse = {
    data: {},
    fetching: true,
    error: null
};
var useElasticFetch = function(param) {
    var query = param.query, _timeout = param.timeout, timeout = _timeout === void 0 ? 500 : _timeout;
    var ref = _slicedToArray((0,react.useState)(defaultResponse), 2), response = ref[0], setResponse = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), initFetched = ref1[0], setInitFetched = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(), 2), currentQuery = ref2[0], setCurrentQuery = ref2[1];
    (0,react.useEffect)(function() {
        if (JSON.stringify(query) === JSON.stringify(currentQuery)) {
            return;
        }
        setCurrentQuery(query);
        if (!initFetched) {
            apiFetch();
            setInitFetched(true);
            return;
        }
        var timer = setTimeout(function() {
            apiFetch();
        }, timeout);
        // eslint-disable-next-line consistent-return
        return function() {
            return clearTimeout(timer);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    var apiFetch = function() {
        var _ref = _asyncToGenerator(function() {
            return __generator(this, function(_state) {
                setResponse({
                    data: {},
                    fetching: false,
                    error: null
                });
                return [
                    2
                ];
            });
        });
        return function apiFetch() {
            return _ref.apply(this, arguments);
        };
    }();
    return response;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
;// CONCATENATED MODULE: ./src/areas/campaign/components/search/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 10px;\n  top: 10px;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin: 0;\n  display: block;\n  outline: none;\n  cursor: text;\n  padding: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 5px;\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: inset 0 0 0 1px ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var SearchIcon = (0,styled_components_browser_esm["default"])(magnifier/* IconMagnifier */.j).attrs(function() {
    return {
        color: "base300"
    };
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-0"
})(styles_templateObject());
var IconButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "IconButton",
    componentId: "sc-0-1"
})(styles_templateObject1());
var SearchInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-2"
})(styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.base300;
}, function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue700;
});

;// CONCATENATED MODULE: ./src/areas/campaign/components/search/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}








var Search = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(Search, _PureComponent);
    var _super = _createSuper(Search);
    function Search() {
        _classCallCheck(this, Search);
        return _super.apply(this, arguments);
    }
    _createClass(Search, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var t = this.context.t;
                // Clear the search input if no query is given
                if (!this.props.query && this.searchInput) {
                    this.searchInput.value = "";
                }
                return /*#__PURE__*/ react.createElement(list_variants.Row, {
                    style: {
                        position: "relative"
                    }
                }, /*#__PURE__*/ react.createElement(SearchInput, {
                    onBlur: function(e) {
                        if (e.currentTarget.value) {
                            _this.props.campaignSearchDone();
                        }
                    },
                    defaultValue: this.props.query,
                    placeholder: t("campaigns", "search.placeholder"),
                    type: "search",
                    onChange: function(e) {
                        return _this.props.onSearch({
                            id: "query",
                            value: e.currentTarget.value
                        });
                    },
                    ref: function(input) {
                        _this.searchInput = input;
                        if (_this.searchInput) {
                            _this.searchInput.value = _this.props.query || "";
                        }
                    }
                }), this.searchInput && this.searchInput.value.length || this.props.query ? /*#__PURE__*/ react.createElement(IconButton, {
                    type: "button",
                    onClick: function() {
                        _this.props.onSearch({
                            id: "query",
                            value: ""
                        });
                        _this.searchInput.value = "";
                        _this.searchInput.focus();
                    }
                }, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
                    size: 12
                })) : /*#__PURE__*/ react.createElement(IconButton, {
                    type: "button",
                    onClick: function() {
                        _this.searchInput.focus();
                    }
                }, /*#__PURE__*/ react.createElement(SearchIcon, {
                    size: 20
                })));
            }
        }
    ]);
    return Search;
}(react.PureComponent);
var func = (prop_types_default()).func, string = (prop_types_default()).string;
Search.propTypes = {
    query: string,
    onSearch: func,
    campaignSearchDone: func.isRequired
};
Search.defaultProps = {
    query: undefined
};
Search.contextType = app_context/* AppContext */.Il;
/* harmony default export */ var components_search = ((0,es/* connect */.$j)(null, actions/* default */.ZP)(Search));

// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/index.tsx
var offers_grid = __webpack_require__(79821);
;// CONCATENATED MODULE: ./src/areas/campaign/components/deals/styles.ts
function deals_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function deals_styles_templateObject() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  width: 100%;\n  a {\n    display: block;\n    margin-top: 1rem;\n    text-decoration: underline;\n  }\n\n  ul {\n    padding-left: 40px;\n  }\n"
    ]);
    deals_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function deals_styles_templateObject1() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n  div:empty,\n  a:empty {\n    height: 0;\n    padding: 0 !important;\n    border-bottom: 0 !important;\n  }\n"
    ]);
    deals_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function deals_styles_templateObject2() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    color: ",
        ";\n    padding: ",
        " ",
        " ",
        " ",
        ";\n  "
    ]);
    deals_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n      display: block;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n  display: none;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = deals_styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n      grid-template-columns: repeat(auto-fill, minmax(auto, calc(",
        " - ",
        ")))\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = deals_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Empty = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Empty",
    componentId: "sc-0-0"
})(deals_styles_templateObject(), base/* layout.margins.component.desktop.rem */.bK.margins.component.desktop.rem);
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-1"
})(deals_styles_templateObject1());
var ProductCount = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductCount",
    componentId: "sc-0-2"
})(styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(deals_styles_templateObject2(), function(p) {
    return p.theme.colors.base600;
}, (0,base/* remCalc */.vR)(5), (0,base/* remCalc */.vR)(0), (0,base/* remCalc */.vR)(10), (0,base/* remCalc */.vR)(0)));
var SearchField = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchField",
    componentId: "sc-0-3"
})(_templateObject5(), function(props) {
    return props.show && (0,styled_components_browser_esm.css)(_templateObject4());
});
var Panel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Panel",
    componentId: "sc-0-4"
})(_templateObject6());
var ITEMS_DESKTOP = 3;
var SIZE_DESKTOP = "".concat(100 / ITEMS_DESKTOP, "%");
var GAP_DESKTOP = 1;
var GUTTER_DESKTOP = "(".concat(GAP_DESKTOP * (ITEMS_DESKTOP - 1), "rem / ").concat(ITEMS_DESKTOP, ")");
var DealsGrid = (0,styled_components_browser_esm["default"])(offers_grid/* OffersGrid */.u).withConfig({
    displayName: "DealsGrid",
    componentId: "sc-0-5"
})(_templateObject8(), base/* media.largeUp */.BC.largeUp(_templateObject7(), SIZE_DESKTOP, GUTTER_DESKTOP));

// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var actions_product = __webpack_require__(69140);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(23513);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(5780);
// EXTERNAL MODULE: ./src/globals/tracking/filter.ts
var filter = __webpack_require__(15301);
;// CONCATENATED MODULE: ./src/areas/campaign/components/deals/types.ts
var SortOptionValueEnum;
(function(SortOptionValueEnum) {
    SortOptionValueEnum["RANK_DESC"] = "rank|desc";
    SortOptionValueEnum["PRODUCT_NAME_KEYWORD"] = "product.name.keyword";
    SortOptionValueEnum["PRODUCT_POPULARITY_TOTAL"] = "product.popularity.total";
    SortOptionValueEnum["PRICE_OFFER_ASC"] = "price.offer|asc";
    SortOptionValueEnum["PRICE_OFFER_DESC"] = "price.offer|desc";
    SortOptionValueEnum["PRODUCT_USER_REVIEWS_RATING_DESC"] = "product.user_reviews.rating|desc";
    SortOptionValueEnum["PRICE_DIFF_PERCENTAGE_DESC"] = "price.diff_percentage|desc";
    SortOptionValueEnum["RELEVANCE"] = "relevance";
})(SortOptionValueEnum || (SortOptionValueEnum = {}));

;// CONCATENATED MODULE: ./src/areas/campaign/components/deals/index.tsx
function deals_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function deals_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function deals_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return deals_arrayLikeToArray(arr);
}
function deals_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function deals_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function deals_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function deals_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function deals_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            deals_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function deals_slicedToArray(arr, i) {
    return deals_arrayWithHoles(arr) || deals_iterableToArrayLimit(arr, i) || deals_unsupportedIterableToArray(arr, i) || deals_nonIterableRest();
}
function deals_toConsumableArray(arr) {
    return deals_arrayWithoutHoles(arr) || deals_iterableToArray(arr) || deals_unsupportedIterableToArray(arr) || deals_nonIterableSpread();
}
function deals_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return deals_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return deals_arrayLikeToArray(o, minLen);
}































var DEFAULT_SIZE = 24;
var DEFAULT_SORT = SortOptionValueEnum.RANK_DESC;
var RATING_OPTION_KEYS = [
    "productRating",
    "storeRating"
];
var ADS_LAYOUT = deals_defineProperty({}, types/* LayoutMode.GRID */.X.GRID, {
    panorama_extra: {
        show: true,
        row: 3
    },
    dubbelpanorama1: {
        show: false,
        row: 8
    },
    dubbelpanorama2: {
        show: true,
        row: 4
    }
});
var buildProductProps = function(_source, renderMode, market) {
    var ref;
    var link = _source.product.web_uri.split(market.domain)[1]; // [<siteDomain>, '/product.php?p=xyz']
    if (renderMode === "desktop" && market.domain) {
        link = _source.product.web_uri.split(market.domain)[1];
    }
    if (renderMode === "native") {
        link = _source.product.web_uri;
    }
    var product = {
        id: _source.product.id,
        name: _source.product.name,
        rating: (_source.product.user_reviews.rating || 0) / 2,
        count: _source.product.user_reviews.count,
        price: (ref = _source.price) === null || ref === void 0 ? void 0 : ref.offer,
        link: link,
        mode: "grid",
        category: {
            name: _source.product.category.name
        },
        image: _source.product.media.product_images.first ? _source.product.media.product_images.first[280] : null,
        stockStatus: _source.product.stock_status
    };
    return product;
};
var Deals = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var onChange = props.onChange, onClear = props.onClear, router = props.router, _size = props.size, size = _size === void 0 ? DEFAULT_SIZE : _size, _showPagination = props.showPagination, showPagination = _showPagination === void 0 ? true : _showPagination, _showProductsHeader = props.showProductsHeader, showProductsHeader = _showProductsHeader === void 0 ? true : _showProductsHeader, campaignId = props.campaignId, campaignName = props.campaignName;
    var ref8 = (0,react.useContext)(app_context/* AppContext */.Il), market = ref8.market, renderMode = ref8.renderMode, t = ref8.t;
    var ref9 = (0,react.useContext)(viewport/* ViewportContext */.R), isMobile = ref9.isMobile, isTablet = ref9.isTablet;
    var search = (0,react_router/* useLocation */.TH)().search;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref10 = deals_slicedToArray((0,react.useState)(false), 2), showSearchField = ref10[0], setShowSearchField = ref10[1];
    var ref11 = deals_slicedToArray((0,react.useState)(buildQuery(props)), 2), currentQuery = ref11[0], setCurrentQuery = ref11[1];
    var ref12 = deals_slicedToArray((0,react.useState)(""), 2), lastSearchQuery = ref12[0], setLastSearchQuery = ref12[1];
    var ref13 = useElasticFetch({
        query: currentQuery,
        // eslint-disable-next-line object-shorthand
        campaignId: campaignId,
        timeout: router.query === lastSearchQuery ? 0 : 500
    }), fetching = ref13.fetching, data = ref13.data;
    (0,react.useEffect)(function() {
        setCurrentQuery(buildQuery(props));
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        var routerQuery = router.query || "";
        if (routerQuery === lastSearchQuery) {
            return;
        }
        setLastSearchQuery(routerQuery);
    }, [
        data
    ]);
    var sortOptions = [
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.RANK_DESC)),
            value: SortOptionValueEnum.RANK_DESC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRODUCT_NAME_KEYWORD)),
            value: SortOptionValueEnum.PRODUCT_NAME_KEYWORD
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL)),
            value: SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRICE_OFFER_ASC)),
            value: SortOptionValueEnum.PRICE_OFFER_ASC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRICE_OFFER_DESC)),
            value: SortOptionValueEnum.PRICE_OFFER_DESC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC)),
            value: SortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC)),
            value: SortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC
        }
    ].concat(deals_toConsumableArray(router.sort === SortOptionValueEnum.RELEVANCE ? [
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.RELEVANCE)),
            value: SortOptionValueEnum.RELEVANCE
        }
    ] : []));
    var addStickyOffset = (0,react.useCallback)(function() {
        if (window.innerWidth < 640) {
            return 50;
        }
        return 70;
    }, []);
    var generatePaginationUrl = (0,react.useCallback)(function(pageNumber) {
        return "?".concat(dist_default().stringify(_objectSpreadProps(_objectSpread({}, dist_default().parse(search.substring(1))), {
            offset: pageNumber > 1 ? (pageNumber - 1) * size : undefined
        })));
    }, [
        search,
        size
    ]);
    var currentSort = ((ref = sortOptions.find(function(item) {
        return router.sort === item.value;
    })) === null || ref === void 0 ? void 0 : ref.value) || DEFAULT_SORT;
    var currentPage = typeof router.offset === "number" && typeof size === "number" ? Math.floor(router.offset / size) + 1 : 1;
    var handleSortChange = function(option) {
        if (option.value) {
            var ref = deals_slicedToArray(option.value.split("|"), 1), property = ref[0];
            (0,filter/* trackSortingSelectEvent */.Em)({
                property: property,
                scope: filter/* PageScope.CAMPAIGN */.VN.CAMPAIGN,
                campaign: campaignName,
                value: option.value
            });
            onChange({
                id: "sort",
                value: option.value
            });
        }
    };
    var productsCountText = ((ref1 = data.hits) === null || ref1 === void 0 ? void 0 : ref1.total) && ((ref2 = data.hits) === null || ref2 === void 0 ? void 0 : ref2.total) > 0 ? t("campaigns", "deals.n-products-subtitle", {
        n: data.hits.total
    }) : undefined;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, showProductsHeader && /*#__PURE__*/ react.createElement(products_header/* ProductsHeader */.i, {
        displayOptions: isMobile || isTablet ? /*#__PURE__*/ react.createElement("button", {
            "data-test": "ShowSearchButton",
            type: "button",
            onClick: function() {
                return setShowSearchField(function(state) {
                    return !state;
                });
            }
        }, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, {
            size: 27,
            color: "maybeBlue700"
        })) : null,
        sortOptions: /*#__PURE__*/ react.createElement(filter_dropdown/* FilterDropdown */.M, {
            defaultSelected: sortOptions.find(function(option) {
                return option.value === currentSort;
            }),
            title: isMobile || isTablet ? "" : t("common", "sort.title"),
            options: sortOptions,
            onFilterChange: function(option) {
                return handleSortChange(option);
            }
        }),
        subtitle: isMobile || isTablet ? undefined : productsCountText,
        title: isMobile || isTablet ? undefined : t("campaigns", "products.title")
    }, isMobile || isTablet ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(hideable.Hideable, {
        collapse: ui/* Axis.Y */.RD.Y,
        visible: showSearchField,
        renderWhenHidden: true
    }, /*#__PURE__*/ react.createElement(SearchField, {
        show: showSearchField,
        "data-test": "SearchField"
    }, /*#__PURE__*/ react.createElement(components_search, {
        query: router.query,
        onSearch: function(item) {
            return onChange(item);
        }
    }))), /*#__PURE__*/ react.createElement(ProductCount, {
        "data-test": "ProductCount"
    }, productsCountText)) : null), !fetching && (!((ref3 = data.hits) === null || ref3 === void 0 ? void 0 : ref3.hits) || data.hits.hits.length === 0) && /*#__PURE__*/ react.createElement(Empty, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "campaigns"
    }, "item.no-results.md"), /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        onClick: onClear
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "campaigns"
    }, "link.view-all"))), ((ref4 = data.hits) === null || ref4 === void 0 ? void 0 : ref4.hits.length) ? /*#__PURE__*/ react.createElement(DealsGrid, {
        className: "deals-grid",
        offers: (ref5 = data.hits) === null || ref5 === void 0 ? void 0 : ref5.hits.map(function(param, index) {
            var _source = param._source, _id = param._id;
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            var product = buildProductProps(_source, renderMode, market);
            var price = _source.price;
            var ref13, _price, ref14, _price1;
            var gridCardProps = {
                categoryName: product.category.name,
                parentCategoryIds: [],
                featured: !!((ref = _source.store) === null || ref === void 0 ? void 0 : ref.featured),
                priceDrop: Math.round(((ref1 = _source.price) === null || ref1 === void 0 ? void 0 : ref1.diff_percentage) || 0),
                offerLink: _source.external_uri.replace("&api_client=1", "&api_client=1331"),
                logo: product.image || "",
                productLink: product.link,
                name: product.name,
                handleCardOnClick: function() {
                    dispatch((0,actions/* campaignItemClick */.d6)(_source));
                    (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */.U.CAMPAIGN_PRODUCT_CARD,
                        nextPage: product.link,
                        index: index
                    });
                },
                handleClickOut: function() {
                    dispatch((0,actions_product/* productPriceClick */.Po)(product.id, typeof product.price === "string" ? parseInt(product.price, 10) : product.price, true, "", false, "Deals"));
                    if (price) {
                        (0,conversion/* trackOfferClickWithRevenue */.Rx)({
                            scope: conversion/* TrackClickScope.CAMPAIGN_LIST_ITEM */.b8.CAMPAIGN_LIST_ITEM,
                            offerId: String(price.id),
                            isRawOffer: false
                        });
                    }
                },
                priceId: (ref13 = (ref2 = _source.price) === null || ref2 === void 0 ? void 0 : ref2.id.toString()) !== null && ref13 !== void 0 ? ref13 : "",
                price: typeof product.price === "string" ? parseInt(product.price, 10) : (_price = product.price) !== null && _price !== void 0 ? _price : 0,
                previousPrice: typeof (price === null || price === void 0 ? void 0 : (ref3 = price.display) === null || ref3 === void 0 ? void 0 : ref3.previousPrice) === "string" ? parseInt(price === null || price === void 0 ? void 0 : (ref4 = price.display) === null || ref4 === void 0 ? void 0 : ref4.previousPrice, 10) : null,
                previousPriceText: (price === null || price === void 0 ? void 0 : price.days_ago_compare) ? t("campaigns", "deals.price-n-days-ago", {
                    /* The date that days_ago_compare is based on is taken from just after midnight,

                                so from a user perspective it makes more sense to say that the comparison is
                                with the price from the day *before* that. A bit confusing, but that's how
                                it seems to work... */ count: price.days_ago_compare + 1
                }) : undefined,
                productRating: product.rating,
                productRatingCount: product.count,
                storeId: ((ref5 = _source.store) === null || ref5 === void 0 ? void 0 : ref5.id) || 0,
                shopOfferId: "",
                storeName: ((ref6 = _source.store) === null || ref6 === void 0 ? void 0 : ref6.name) || "",
                storeCount: ((ref7 = _source.product.price) === null || ref7 === void 0 ? void 0 : ref7.count_regular) || 0,
                priceUpdateTime: "",
                productId: product.id,
                showDropdown: true,
                imageSearchModels: [],
                coreProperties: [],
                promotionShopPrices: [],
                bestOffer: {
                    storeId: ((ref8 = _source.store) === null || ref8 === void 0 ? void 0 : ref8.id) || 0,
                    shopOfferId: "",
                    stockStatus: product.stockStatus,
                    storeName: ((ref9 = _source.store) === null || ref9 === void 0 ? void 0 : ref9.name) || "",
                    priceId: (ref14 = (ref10 = _source.price) === null || ref10 === void 0 ? void 0 : ref10.id.toString()) !== null && ref14 !== void 0 ? ref14 : "",
                    price: typeof product.price === "string" ? parseInt(product.price, 10) : (_price1 = product.price) !== null && _price1 !== void 0 ? _price1 : 0,
                    offerLink: _source.external_uri.replace("&api_client=1", "&api_client=1331"),
                    featured: !!((ref11 = _source.store) === null || ref11 === void 0 ? void 0 : ref11.featured),
                    membershipRequiresCompensation: false
                }
            };
            return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
                key: _id,
                diffPercentage: Math.round(((ref12 = _source.price) === null || ref12 === void 0 ? void 0 : ref12.diff_percentage) || 0),
                onClick: function() {
                    dispatch((0,actions/* campaignItemClick */.d6)(_source));
                    (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */.U.CAMPAIGN_PRODUCT_CARD,
                        nextPage: product.link,
                        index: index
                    });
                },
                product: _objectSpreadProps(_objectSpread({}, product), {
                    store: _source.store ? {
                        id: _source.store.id,
                        name: _source.store.name,
                        hasLogo: !!_source.store.logo,
                        featured: !!_source.store.featured
                    } : undefined,
                    media: {
                        first: product.image
                    }
                })
            }, /*#__PURE__*/ react.createElement(DealsCardContextContainer, _extends({}, gridCardProps), /*#__PURE__*/ react.createElement(DealsCard, null)));
        })
    }, /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
        offersLength: ((ref6 = data.hits) === null || ref6 === void 0 ? void 0 : ref6.hits.length) || 0,
        layout: types/* LayoutMode.GRID */.X.GRID,
        layoutConfig: ADS_LAYOUT,
        scaleBase: "deals-grid",
        async: true
    })) : null, fetching && /*#__PURE__*/ react.createElement(placeholder/* Placeholder */.V, {
        height: 450,
        amount: 12,
        rows: 8
    }), showPagination && /*#__PURE__*/ react.createElement(components_scroll/* ScrollLink */.Rv, {
        to: "CampaignHeaderAd",
        shouldScroll: function(param) {
            var tagName = param.tagName;
            return tagName === "A";
        },
        animate: false,
        calculateOffset: addStickyOffset
    }, /*#__PURE__*/ react.createElement(number_pagination/* NumberPagination */.O, {
        currentPage: currentPage,
        totalPages: Math.ceil((((ref7 = data.hits) === null || ref7 === void 0 ? void 0 : ref7.total) || 0) / size),
        linkToPage: generatePaginationUrl,
        onClick: function(item) {
            onChange({
                id: "offset",
                value: item.pageNumber > 1 ? (item.pageNumber - 1) * size : 0,
                deleteOffset: false
            });
        }
    })));
};
var buildQuery = function(props) {
    var ref = deals_slicedToArray((props.router.sort || DEFAULT_SORT).split("|"), 2), sort = ref[0], order = ref[1];
    var offset = props.router.offset || 0;
    var _router = props.router, categories = _router.categories, query = _router.query, filterRanges = _router.filterRanges;
    var size = props.size;
    var stores = props.router.stores;
    if (props.stores && props.stores.length) {
        // Stores can come both from the url or as props. Props have the higher priority atm in order to prevent weird behavior.
        stores = props.stores;
    }
    var body = {
        _source: {
            include: [
                "price.display.*",
                "price.diff_percentage",
                "price.days_ago_compare",
                "price.id",
                "price.offer",
                "price.offer_incl_shipping",
                "product.id",
                "product.semantic_id",
                "product.web_uri",
                "product.mobile_web_uri",
                "product.name",
                "product.media",
                "product.price.count",
                "product.price.count_regular",
                "product.statistics.sparklines",
                "product.category.name",
                "product.user_reviews.rating",
                "product.user_reviews.count",
                "product.stock_status",
                "brand.logo",
                "brand.name",
                "store.name",
                "store.id",
                "store.logo",
                "store.featured",
                "external_uri"
            ]
        },
        from: offset,
        size: size || DEFAULT_SIZE
    };
    var selectionGroups = [];
    // Use the score first if the current sort is relevance
    body.sort = sort === SortOptionValueEnum.RELEVANCE ? [
        "_score"
    ] : [
        deals_defineProperty({}, sort, {
            order: order || "asc",
            unmapped_type: sort === SortOptionValueEnum.PRODUCT_NAME_KEYWORD ? "keyword" : "long"
        }),
        "_score"
    ];
    if (sort === DEFAULT_SORT.split("|")[0]) {
        body.sort.push(deals_defineProperty({}, SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL, {
            unmapped_type: "long"
        }));
    }
    if (categories === null || categories === void 0 ? void 0 : categories.length) {
        selectionGroups.push({
            bool: {
                should: categories.map(function(value) {
                    return {
                        term: {
                            "product.category.path.id": value
                        }
                    };
                })
            }
        });
    }
    if (stores) {
        selectionGroups.push({
            bool: {
                should: stores.map(function(value) {
                    return {
                        term: {
                            "store.id": value
                        }
                    };
                })
            }
        });
    }
    body.query = {
        bool: {
            must: selectionGroups
        }
    };
    body.query.bool.filter = {
        bool: {
            must: []
        }
    };
    props.rangeOptions.forEach(function(option) {
        if (filterRanges && option.key && filterRanges[option.key]) {
            var filter = {
                range: {}
            };
            if (option.field) filter.range[option.field] = {
                gte: RATING_OPTION_KEYS.includes(option.key) ? filterRanges[option.key].from * 2 // Ratings are between 1-10
                 : filterRanges[option.key].from,
                lte: RATING_OPTION_KEYS.includes(option.key) ? filterRanges[option.key].to * 2 // Ratings are between 1-10
                 : filterRanges[option.key].to
            };
            if (body.query.bool.filter) body.query.bool.filter.bool.must.push(filter);
        }
    });
    if (query) {
        body.query.bool.must = body.query.bool.must.concat(campaign_query(query));
    }
    return body;
};

// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(85732);
// EXTERNAL MODULE: ./src/areas/store/actions/index.js
var store_actions = __webpack_require__(43641);
// EXTERNAL MODULE: ./src/components/modal/modal.tsx + 1 modules
var modal = __webpack_require__(2869);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-store-popup/styles.ts
function campaign_store_popup_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_store_popup_styles_templateObject() {
    var data = campaign_store_popup_styles_taggedTemplateLiteral([
        "\n    width: 90% !important;\n  "
    ]);
    campaign_store_popup_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_store_popup_styles_templateObject1() {
    var data = campaign_store_popup_styles_taggedTemplateLiteral([
        "\n    width: 90% !important;\n  "
    ]);
    campaign_store_popup_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function campaign_store_popup_styles_templateObject2() {
    var data = campaign_store_popup_styles_taggedTemplateLiteral([
        "\n    width: 60% !important;\n  "
    ]);
    campaign_store_popup_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function campaign_store_popup_styles_templateObject3() {
    var data = campaign_store_popup_styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    campaign_store_popup_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = campaign_store_popup_styles_taggedTemplateLiteral([
        "\n  margin: auto;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StorePopupModal = (0,styled_components_browser_esm["default"])(modal["default"]).withConfig({
    displayName: "StorePopupModal",
    componentId: "sc-0-0"
})(campaign_store_popup_styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(campaign_store_popup_styles_templateObject()), base/* media.mediumOnly */.BC.mediumOnly(campaign_store_popup_styles_templateObject1()), base/* media.largeUp */.BC.largeUp(campaign_store_popup_styles_templateObject2()));
var StyledOutlineButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledOutlineButton",
    componentId: "sc-0-1"
})(styles_templateObject4());

// EXTERNAL MODULE: ./src/components/clickout-wrapper/index.tsx
var clickout_wrapper = __webpack_require__(87526);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-store-popup/index.tsx












var CampaignStorePopup = function(param) {
    var router = param.router, shop = param.shop, _onRequestClose = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onRequestClose, onRequestClose = _onRequestClose === void 0 ? function() {} : _onRequestClose, campaign = param.campaign, _dealCount = param.dealCount, dealCount = _dealCount === void 0 ? 8 : _dealCount;
    var dispatch = (0,es/* useDispatch */.I0)();
    var t = (0,app_context/* useAppContext */.bp)().t;
    var onClick = (0,react.useCallback)(function() {
        dispatch((0,store_actions/* storeLinkClick */.P)(shop));
        (0,conversion/* trackShopClickWithRevenue */.Yn)({
            shopId: shop.id,
            scope: conversion/* TrackClickScope.CAMPAIGN_SHOP_POPUP */.b8.CAMPAIGN_SHOP_POPUP
        });
    }, [
        dispatch,
        shop
    ]);
    if (!campaign) return null;
    return /*#__PURE__*/ react.createElement(StorePopupModal, {
        isOpen: true,
        shouldShowCloseIcon: true,
        onRequestClose: onRequestClose
    }, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, shop.featured ? /*#__PURE__*/ react.createElement(clickout_wrapper/* ClickoutWrapper */.W, null, /*#__PURE__*/ react.createElement(variants.BodyMediumText, {
        container: "a",
        containerProps: {
            target: "_blank",
            rel: "nofollow noopener",
            onClick: onClick,
            href: shop.external_uri
        }
    }, /*#__PURE__*/ react.createElement("img", {
        width: 176,
        alt: shop.name,
        src: shop.logo && (shop.logo["176"] || shop.logo["96"]),
        style: {
            display: "block"
        }
    }), "".concat(shop.name, " - ").concat(t("search", "raw-search.go-to-shop")))) : /*#__PURE__*/ react.createElement(variants.H3Text, null, shop.name), campaign.id && campaign.name && /*#__PURE__*/ react.createElement(Deals, {
        campaignId: campaign.id,
        campaignName: campaign.name,
        router: router,
        rangeOptions: [],
        size: dealCount,
        stores: [
            String(shop.id)
        ],
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: function() {},
        showPagination: false,
        showProductsHeader: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClear: function() {}
    }), /*#__PURE__*/ react.createElement(StyledOutlineButton, {
        style: {
            textAlign: "center"
        }
    }, /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
        campaign: campaign,
        queryString: "?stores=".concat(shop.id),
        linkContent: /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, null, t("campaigns", "link.view-all"))
    }))));
};
/* harmony default export */ var campaign_store_popup = (CampaignStorePopup);

// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-group/index.js + 1 modules
var campaign_group = __webpack_require__(13066);
;// CONCATENATED MODULE: ./src/areas/campaign/styles.ts
function campaign_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_styles_templateObject() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n    flex: 1 1 0%;\n  "
    ]);
    campaign_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_styles_templateObject1() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  min-width: 0;\n  flex: 1 1 auto;\n\n  ",
        ";\n"
    ]);
    campaign_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function campaign_styles_templateObject2() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    campaign_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function campaign_styles_templateObject3() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n  "
    ]);
    campaign_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function campaign_styles_templateObject4() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n\n  ",
        ";\n"
    ]);
    campaign_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = campaign_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var flexStyle = (0,styled_components_browser_esm.css)(campaign_styles_templateObject1(), base/* media.largeUp */.BC.largeUp(campaign_styles_templateObject()));
var gutterStyle = (0,styled_components_browser_esm.css)(campaign_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var dividerStyle = (0,styled_components_browser_esm.css)(campaign_styles_templateObject4(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumDown */.BC.mediumDown(campaign_styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var StyledGutterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledGutterWrapper",
    componentId: "sc-0-0"
})(styles_templateObject5(), flexStyle, gutterStyle);
var StyledCampaign = styled_components_browser_esm["default"].section.attrs({
    "data-test": "CampaignSection"
}).withConfig({
    displayName: "StyledCampaign",
    componentId: "sc-0-1"
})(styles_templateObject6(), function(p) {
    return p.theme.colors.base0;
});
var StyledProductWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledProductWrapper",
    componentId: "sc-0-2"
})(styles_templateObject7());
var StyledProducts = styled_components_browser_esm["default"].section.withConfig({
    displayName: "StyledProducts",
    componentId: "sc-0-3"
})(styles_templateObject8(), flexStyle);
var StyledCampaignGrouping = (0,styled_components_browser_esm["default"])(campaign_group/* default */.Z).withConfig({
    displayName: "StyledCampaignGrouping",
    componentId: "sc-0-4"
})(_templateObject9(), gutterStyle, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/campaign/components/popular-stores/styles.ts
function popular_stores_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function popular_stores_styles_templateObject() {
    var data = popular_stores_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n\n  && {\n    min-width: 100%;\n  }\n"
    ]);
    popular_stores_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(popular_stores_styles_templateObject(), flexStyle, gutterStyle);

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
;// CONCATENATED MODULE: ./src/areas/campaign/components/popular-stores/index.tsx
function popular_stores_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function popular_stores_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function popular_stores_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function popular_stores_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function popular_stores_slicedToArray(arr, i) {
    return popular_stores_arrayWithHoles(arr) || popular_stores_iterableToArrayLimit(arr, i) || popular_stores_unsupportedIterableToArray(arr, i) || popular_stores_nonIterableRest();
}
function popular_stores_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return popular_stores_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return popular_stores_arrayLikeToArray(o, minLen);
}












var PopularStores = function(props) {
    var toggleStoreCampaignItemsPopup = function toggleStoreCampaignItemsPopup(shop) {
        setCurrentShop(shop);
    };
    var ref, ref1, ref2;
    var ref3 = popular_stores_slicedToArray(react.useState(undefined), 2), currentShop = ref3[0], setCurrentShop = ref3[1];
    var ref4 = (0,app_context/* useAppContext */.bp)(), market = ref4.market, t = ref4.t;
    var vp = (0,context/* useViewportContext */.Ak)();
    var dailyDeals = props.dailyDeals, router = props.router;
    var ref5 = vp.isDesktop ? {
        numberOfStores: 20,
        dealCount: 8
    } : {
        numberOfStores: 4,
        dealCount: 4
    }, numberOfStores = ref5.numberOfStores, dealCount = ref5.dealCount;
    var data = useElasticFetch({
        query: {},
        campaignId: props.campaignId,
        timeout: 1500
    }).data;
    // This page needs to be reworked when new deals page starts supporting shop filters
    if (market.code !== "nz") {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, {
        style: {
            flexWrap: "wrap"
        }
    }, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("campaigns", "inactive-campaign.popular-stores")), (dailyDeals === null || dailyDeals === void 0 ? void 0 : (ref = dailyDeals.web_uri) === null || ref === void 0 ? void 0 : ref.responsive) && /*#__PURE__*/ react.createElement(variants.BodyMediumText, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: dailyDeals.web_uri.responsive,
            onClick: function() {
                var ref, ref1;
                return ((ref = dailyDeals.web_uri) === null || ref === void 0 ? void 0 : ref.responsive) && (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CAMPAIGN_HEADER */.U.CAMPAIGN_HEADER,
                    nextPage: (ref1 = dailyDeals.web_uri) === null || ref1 === void 0 ? void 0 : ref1.responsive
                });
            }
        }
    }, t("campaigns", "link.view-all"))), /*#__PURE__*/ react.createElement(flexible_grid/* Grid */.r, {
        columnTemplate: "repeat(auto-fit, minmax(min(100%/2, max(143px, 100%/5)), 1fr))"
    }, (data === null || data === void 0 ? void 0 : (ref1 = data.aggregations) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.stores) === null || ref2 === void 0 ? void 0 : ref2.buckets) && data.aggregations.stores.buckets.slice(0, numberOfStores).map(function(hit) {
        var shop = hit.top_hits.hits.hits[0]._source.store;
        return /*#__PURE__*/ react.createElement(ShopCard, {
            key: hit.key,
            name: shop.name,
            featured: shop.featured,
            logo: shop.logo && (shop.logo["176"] || shop.logo["96"]),
            onClick: function() {
                return toggleStoreCampaignItemsPopup(shop);
            }
        });
    })), currentShop && dailyDeals && /*#__PURE__*/ react.createElement(campaign_store_popup, {
        router: router,
        campaign: dailyDeals,
        shop: currentShop,
        dealCount: dealCount,
        onRequestClose: function() {
            return toggleStoreCampaignItemsPopup();
        }
    }));
};

// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(24562);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/index.tsx + 3 modules
var product_alert_form = __webpack_require__(56752);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
// EXTERNAL MODULE: ./src/components/entity-search/search-box/index.tsx + 10 modules
var search_box = __webpack_require__(98473);
// EXTERNAL MODULE: ./src/components/entity-search/container.tsx + 1 modules
var container = __webpack_require__(72418);
;// CONCATENATED MODULE: ./src/areas/campaign/components/product-alert-box/styles.ts
function product_alert_box_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_alert_box_styles_templateObject() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    product_alert_box_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_alert_box_styles_templateObject1() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n    min-width: 100%;\n  "
    ]);
    product_alert_box_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_alert_box_styles_templateObject2() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  & > * {\n    flex: none;\n  }\n\n  max-width: 33%;\n\n  ",
        "\n"
    ]);
    product_alert_box_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_alert_box_styles_templateObject3() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: 5px 5px 0 0;\n"
    ]);
    product_alert_box_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_alert_box_styles_templateObject4() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  & > * {\n    min-width: 100%;\n  }\n\n  background: ",
        ";\n  padding: 0 ",
        " ",
        ";\n  border-radius: 0 0 5px 5px;\n"
    ]);
    product_alert_box_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var RoundedBluePanel = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "RoundedBluePanel",
    componentId: "sc-0-0"
})(product_alert_box_styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.maybeBlue700;
});
var TextColumn = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "TextColumn",
    componentId: "sc-0-1"
})(product_alert_box_styles_templateObject2(), base/* media.smallOnly */.BC.smallOnly(product_alert_box_styles_templateObject1()));
var SelectedProductRow = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "SelectedProductRow",
    componentId: "sc-0-2"
})(product_alert_box_styles_templateObject3(), function(p) {
    return p.theme.colors.base0;
});
var AlertFormWrapper = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "AlertFormWrapper",
    componentId: "sc-0-3"
})(product_alert_box_styles_templateObject4(), function(p) {
    return p.theme.colors.base0;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/campaign/components/product-alert-box/index.js
function product_alert_box_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function product_alert_box_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function product_alert_box_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function product_alert_box_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) product_alert_box_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) product_alert_box_defineProperties(Constructor, staticProps);
    return Constructor;
}
function product_alert_box_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_alert_box_getPrototypeOf(o) {
    product_alert_box_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return product_alert_box_getPrototypeOf(o);
}
function product_alert_box_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) product_alert_box_setPrototypeOf(subClass, superClass);
}
function product_alert_box_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_alert_box_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_alert_box_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_alert_box_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_alert_box_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function product_alert_box_possibleConstructorReturn(self, call) {
    if (call && (product_alert_box_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return product_alert_box_assertThisInitialized(self);
}
function product_alert_box_setPrototypeOf(o, p) {
    product_alert_box_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return product_alert_box_setPrototypeOf(o, p);
}
var product_alert_box_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function product_alert_box_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function product_alert_box_createSuper(Derived) {
    var hasNativeReflectConstruct = product_alert_box_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = product_alert_box_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = product_alert_box_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return product_alert_box_possibleConstructorReturn(this, result);
    };
}















var ProductAlertBox = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    product_alert_box_inherits(ProductAlertBox, _PureComponent);
    var _super = product_alert_box_createSuper(ProductAlertBox);
    function ProductAlertBox(props) {
        product_alert_box_classCallCheck(this, ProductAlertBox);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            item: undefined
        };
        return _this;
    }
    product_alert_box_createClass(ProductAlertBox, [
        {
            key: "getPrivacyUrl",
            value: function getPrivacyUrl() {
                var _context = this.context, market = _context.market, renderMode = _context.renderMode;
                return (market.privacySettings[renderMode] || market.privacySettings.responsive).privacyUrl;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, sending = _props.sending, error = _props.error, createAlertRequest = _props.createAlertRequest, removeAlertRequest = _props.removeAlertRequest, campaignName = _props.campaignName, isAuthenticated = _props.isAuthenticated;
                var _context = this.context, t = _context.t, linkTo = _context.linkTo, market = _context.market;
                var item = this.state.item;
                if (item) {
                    item.stockStatus = "in_stock";
                }
                if (!market.login.enabled || !isAuthenticated) {
                    return null;
                }
                return /*#__PURE__*/ react.createElement(RoundedBluePanel, {
                    gap: 1
                }, /*#__PURE__*/ react.createElement(TextColumn, null, /*#__PURE__*/ react.createElement(variants.BodyLargeText, {
                    color: "light"
                }, t("campaigns", "inactive-campaign.alert-box-title")), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
                    color: "light"
                }, t("campaigns", "inactive-campaign.alert-box-description", {
                    campaignName: campaignName
                }))), /*#__PURE__*/ react.createElement(list_variants.Column, {
                    style: {
                        position: "relative"
                    }
                }, item ? /*#__PURE__*/ react.createElement(SelectedProductRow, null, /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                    key: item.id,
                    id: item.id,
                    link: linkTo("product", item),
                    name: item.name,
                    image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                        name: item.name,
                        src: item.image
                    }),
                    rating: item.rating,
                    price: item.price
                }), /*#__PURE__*/ react.createElement(button_variants.IconButton, {
                    onlyIcon: true,
                    onClick: function() {
                        return _this.setState({
                            item: undefined
                        });
                    }
                }, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(icon_close.IconClose, null)))) : /*#__PURE__*/ react.createElement(search_box/* SearchBox */.R, {
                    onSelect: function(selectedItem) {
                        return _this.setState({
                            item: selectedItem
                        });
                    },
                    showFloatingResult: true,
                    placeholder: t("campaigns", "inactive-campaign.alert-box-search-placeholder"),
                    searchMode: container/* SearchMode.PRODUCTS */.N.PRODUCTS,
                    useAbsolute: true
                }), item && /*#__PURE__*/ react.createElement(AlertFormWrapper, null, /*#__PURE__*/ react.createElement(product_alert_form/* ProductAlertForm */.u, {
                    productAlertFormData: {
                        product: product_alert_box_objectSpreadProps(product_alert_box_objectSpread({}, item), {
                            priceSummary: {
                                regular: item.priceRaw
                            }
                        })
                    },
                    disabled: sending,
                    error: error,
                    showTypeSelect: false,
                    onCreate: function(alert) {
                        return createAlertRequest(alert, item.pathName);
                    },
                    onRemove: function(alertId) {
                        return removeAlertRequest(alertId, item.id, item.pathName);
                    },
                    privacyPolicyUri: this.getPrivacyUrl(),
                    showCancel: false,
                    alertType: "PRICE_DROPS",
                    showRemoveButton: false
                }))));
            }
        }
    ]);
    return ProductAlertBox;
}(react.PureComponent);
var product_alert_box_func = (prop_types_default()).func, bool = (prop_types_default()).bool, product_alert_box_string = (prop_types_default()).string, oneOfType = (prop_types_default()).oneOfType;
ProductAlertBox.contextType = app_context/* AppContext */.Il;
ProductAlertBox.propTypes = {
    createAlertRequest: product_alert_box_func.isRequired,
    removeAlertRequest: product_alert_box_func.isRequired,
    sending: bool.isRequired,
    success: bool.isRequired,
    error: oneOfType([
        bool,
        product_alert_box_string
    ]).isRequired,
    campaignName: product_alert_box_string.isRequired,
    isAuthenticated: bool.isRequired
};
var dispatchActions = {
    createAlertRequest: actions_alert/* createAlertRequest */.$b,
    removeAlertRequest: actions_alert/* removeAlertRequest */.s$
};
/* harmony default export */ var product_alert_box = ((0,es/* connect */.$j)(function(state) {
    return {
        sending: state.areas.productAlert.sending,
        success: state.areas.productAlert.success,
        error: state.areas.productAlert.error,
        isAuthenticated: state.areas.account.isAuthenticated
    };
}, dispatchActions)(ProductAlertBox));

// EXTERNAL MODULE: ./src/components/featured-article/index.tsx + 5 modules
var featured_article = __webpack_require__(83068);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-articles/styles.ts
function campaign_articles_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_articles_styles_templateObject() {
    var data = campaign_articles_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    campaign_articles_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Articles = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Articles",
    componentId: "sc-0-0"
})(campaign_articles_styles_templateObject(), flexStyle, dividerStyle, gutterStyle);

;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-articles/index.js






var CampaignArticles = function(param) {
    var featuredArticle = param.featuredArticle, articles = param.articles, campaignName = param.campaignName;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Articles, null, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("campaigns", "article.related-articles", {
        campaignName: campaignName
    })), /*#__PURE__*/ react.createElement(featured_article/* FeaturedArticle */.h, {
        // If no featured article was found show first article
        article: featuredArticle || articles[0],
        related: articles
    })));
};
var campaign_articles_string = (prop_types_default()).string, number = (prop_types_default()).number, shape = (prop_types_default()).shape, arrayOf = (prop_types_default()).arrayOf;
var articleShape = shape({
    id: number,
    publishedAt: campaign_articles_string,
    title: campaign_articles_string,
    preamble: campaign_articles_string,
    imageUrl: campaign_articles_string,
    imageCaption: campaign_articles_string,
    pathName: campaign_articles_string
});
CampaignArticles.propTypes = {
    featuredArticle: articleShape,
    articles: arrayOf(articleShape),
    campaignName: campaign_articles_string
};
CampaignArticles.defaultProps = {
    featuredArticle: null,
    articles: [],
    campaignName: ""
};
/* harmony default export */ var campaign_articles = (CampaignArticles);

;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-inactive/styles.ts
function campaign_inactive_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_inactive_styles_templateObject() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    campaign_inactive_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_inactive_styles_templateObject1() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n"
    ]);
    campaign_inactive_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function campaign_inactive_styles_templateObject2() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n    scale: 0.75;\n  "
    ]);
    campaign_inactive_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function campaign_inactive_styles_templateObject3() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    campaign_inactive_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var PanelWithGutter = (0,styled_components_browser_esm["default"])(panel/* Panel */.s_).withConfig({
    displayName: "PanelWithGutter",
    componentId: "sc-0-0"
})(campaign_inactive_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RowWithWrap = (0,styled_components_browser_esm["default"])(list_variants.GridRow).withConfig({
    displayName: "RowWithWrap",
    componentId: "sc-0-1"
})(campaign_inactive_styles_templateObject1());
var FlipClockWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FlipClockWrapper",
    componentId: "sc-0-2"
})(campaign_inactive_styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(campaign_inactive_styles_templateObject2()));

;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-inactive/index.tsx












var CampaignInactive = function(props) {
    var campaign = props.campaign, targetDate = props.targetDate, dailyDeals = props.dailyDeals, router = props.router, campaignDeals = props.campaignDeals;
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t;
    if (!campaign) return null;
    var articles = campaign.articles;
    var featuredArticle = articles ? articles.find(function(item) {
        return item === null || item === void 0 ? void 0 : item.featured;
    }) : null;
    var upcoming = campaign.state === "UPCOMING";
    var legacyRenderMode = [
        "desktop",
        "mobile",
        "native"
    ].includes(renderMode);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PanelWithGutter, null, !legacyRenderMode && campaign.name && /*#__PURE__*/ react.createElement(product_alert_box, {
        campaignName: campaign.name
    }), upcoming && /*#__PURE__*/ react.createElement(RowWithWrap, null, targetDate && /*#__PURE__*/ react.createElement(FlipClockWrapper, null, /*#__PURE__*/ react.createElement(flip_clock/* FlipClock */.d, {
        targetDate: targetDate,
        daysLabel: t("common", "time.day", {
            n: 0
        }),
        hoursLabel: t("common", "time.hour", {
            n: 0
        }),
        minutesLabel: t("common", "time.minute", {
            n: 0
        }),
        secondsLabel: t("common", "time.second", {
            n: 0
        })
    })), campaign.name && /*#__PURE__*/ react.createElement(newsletter_signup/* NewsletterSignup */.o, {
        title: t("campaigns", "newsletter.sign-up-title", {
            campaignName: campaign.name
        }),
        description: t("campaigns", "newsletter.sign-up-description"),
        stacked: false
    })), /*#__PURE__*/ react.createElement(campaign_deals/* default */.Z, {
        deals: campaignDeals
    })), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(campaign_articles, {
        featuredArticle: featuredArticle,
        articles: articles,
        campaignName: campaign.name
    })), router && /*#__PURE__*/ react.createElement(PopularStores, {
        dailyDeals: dailyDeals,
        campaignId: campaign_ids/* CampaignIdEnum.DAILY_DEALS_ID */.pw.DAILY_DEALS_ID,
        router: router
    }), !upcoming && /*#__PURE__*/ react.createElement(PanelWithGutter, null, /*#__PURE__*/ react.createElement(variants.H2Text, null, t("campaigns", "ended.title")), /*#__PURE__*/ react.createElement(variants.H3Text, null, t("campaigns", "ended.subtitle"))));
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/components/content-wrapper/index.tsx + 41 modules
var content_wrapper = __webpack_require__(35350);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-active-campaign-article/index.tsx




var ActiveCampaignArticle = function() {
    var ref;
    var campaign = (0,deals_context/* useDealsContext */.Yz)().campaign;
    var isActiveCampaign = (campaign === null || campaign === void 0 ? void 0 : campaign.state) === "ACTIVE";
    if (!isActiveCampaign) return null;
    return /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(campaign_articles, {
        featuredArticle: (ref = campaign.articles) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item === null || item === void 0 ? void 0 : item.featured;
        }),
        articles: campaign.articles,
        campaignName: campaign.name
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/breadcrumbs/index.js
var breadcrumbs = __webpack_require__(100);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-breadcrumbs/styles.ts
function deals_breadcrumbs_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function deals_breadcrumbs_styles_templateObject() {
    var data = deals_breadcrumbs_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " 10px;\n"
    ]);
    deals_breadcrumbs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledBreadcrumbs = (0,styled_components_browser_esm["default"])(breadcrumbs/* Breadcrumbs */.O).withConfig({
    displayName: "StyledBreadcrumbs",
    componentId: "sc-0-0"
})(deals_breadcrumbs_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-breadcrumbs/index.tsx






var DealsBreadcrumbs = function(props) {
    var article = props.article;
    var campaign = (0,deals_context/* useDealsContext */.Yz)().campaign;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var campaignBasePath = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.campaign.base;
    });
    return /*#__PURE__*/ react.createElement(StyledBreadcrumbs, null, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/"
    }, t("common", "breadcrumb.home")), campaignBasePath && /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: campaignBasePath
    }, t("campaigns", "themes.breadcrumb")), campaign && /*#__PURE__*/ react.createElement("span", null, campaign.name), article && /*#__PURE__*/ react.createElement("span", null, article.title));
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/components/description-text/index.tsx + 2 modules
var description_text = __webpack_require__(61961);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-header/utils.ts
var getNameOfSingleCategoryFilter = function(searchState) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var singleCategoryId = ((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 ? (ref2 = searchState.filters) === null || ref2 === void 0 ? void 0 : ref2.category[0] : null;
    return (ref5 = (ref3 = searchState.result) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.categoryAggregations) === null || ref4 === void 0 ? void 0 : ref4.find(function(cat) {
        return cat.key === singleCategoryId;
    })) === null || ref5 === void 0 ? void 0 : ref5.name;
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-header/styles.ts
function deals_header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function deals_header_styles_templateObject() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  margin: ",
        " 10px;\n"
    ]);
    deals_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function deals_header_styles_templateObject1() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  column-gap: ",
        ";\n"
    ]);
    deals_header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function deals_header_styles_templateObject2() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  "
    ]);
    deals_header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function deals_header_styles_templateObject3() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n\n  ",
        "\n"
    ]);
    deals_header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function deals_header_styles_templateObject4() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n    flex: 1;\n    column-gap: 0;\n  "
    ]);
    deals_header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function deals_header_styles_templateObject5() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  column-gap: ",
        ";\n  row-gap: ",
        ";\n  flex-wrap: wrap;\n\n  ",
        "\n"
    ]);
    deals_header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function deals_header_styles_templateObject6() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n    line-height: ",
        ";\n  "
    ]);
    deals_header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function deals_header_styles_templateObject7() {
    var data = deals_header_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  margin: 0;\n\n  ",
        "\n"
    ]);
    deals_header_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_DESKTOP = "52px";
var CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_MOBILE = "39px";
var StyledHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-0"
})(deals_header_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledTitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleWrapper",
    componentId: "sc-0-1"
})(deals_header_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-2"
})(deals_header_styles_templateObject3(), CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_DESKTOP, base/* media.smallOnly */.BC.smallOnly(deals_header_styles_templateObject2(), CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_MOBILE));
var StyledTitleInner = styled_components_browser_esm["default"].div.attrs({
    "data-test": "DealsHeader"
}).withConfig({
    displayName: "StyledTitleInner",
    componentId: "sc-0-3"
})(deals_header_styles_templateObject5(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(deals_header_styles_templateObject4()));
var StyledTitle = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-4"
})(deals_header_styles_templateObject7(), base/* media.smallOnly */.BC.smallOnly(deals_header_styles_templateObject6(), CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_MOBILE));

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-header/index.tsx








var DealsHeader = function(param) {
    var breadcrumbs = param.breadcrumbs, searchPageType = param.searchPageType;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,app_context/* useAppContext */.bp)(), renderMode = ref4.renderMode, market = ref4.market;
    var searchState = (0,search_context/* useSearchContext */.AB)().searchState;
    var ref5 = (0,deals_context/* useDealsContext */.Yz)(), campaign = ref5.campaign, headerImage = ref5.headerImage;
    var campaignTitle = (campaign === null || campaign === void 0 ? void 0 : (ref = campaign.title) === null || ref === void 0 ? void 0 : ref.short) || "";
    var readMoreLink = (ref1 = market.articles) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.aboutDealsCalculation) === null || ref2 === void 0 ? void 0 : ref2.path;
    var singleCategoryName = getNameOfSingleCategoryFilter(searchState);
    var headerTitle = singleCategoryName ? "".concat(campaignTitle, " - ").concat(singleCategoryName) : campaignTitle;
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "pageHeader"
    }, renderMode !== "native" && breadcrumbs, /*#__PURE__*/ react.createElement(StyledHeader, null, /*#__PURE__*/ react.createElement(StyledTitleWrapper, null, headerImage && /*#__PURE__*/ react.createElement(StyledImage, {
        src: headerImage
    }), /*#__PURE__*/ react.createElement(StyledTitleInner, null, /*#__PURE__*/ react.createElement(StyledTitle, null, headerTitle))), /*#__PURE__*/ react.createElement(description_text/* DescriptionText */.R, {
        descriptionText: campaign === null || campaign === void 0 ? void 0 : (ref3 = campaign.description) === null || ref3 === void 0 ? void 0 : ref3.page,
        searchPageType: searchPageType,
        readMoreLink: readMoreLink
    })));
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/types.ts
var shared_types = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/styles.ts
function deals_page_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function deals_page_styles_templateObject() {
    var data = deals_page_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        ";\n"
    ]);
    deals_page_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledOngoingCampaignsInfo = (0,styled_components_browser_esm["default"])(campaign_group/* default */.Z).withConfig({
    displayName: "StyledOngoingCampaignsInfo",
    componentId: "sc-0-0"
})(deals_page_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/deals-page/types.ts
var deals_page_types = __webpack_require__(96705);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/deals-page/components/deals-header/types.ts
var deals_header_types = __webpack_require__(79532);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/contexts/utils.ts



var extractCampaignData = function(campaignData) {
    var ref, ref1;
    var campaign = campaignData === null || campaignData === void 0 ? void 0 : campaignData.campaign;
    var campaigns = (campaignData === null || campaignData === void 0 ? void 0 : campaignData.campaigns) || [];
    var isActiveCampaign = (campaign === null || campaign === void 0 ? void 0 : campaign.state) === deals_page_types/* CampaignStateEnum.ACTIVE */.k.ACTIVE;
    var activeCampaigns = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== (campaign === null || campaign === void 0 ? void 0 : campaign.id) && (item === null || item === void 0 ? void 0 : item.state) === deals_page_types/* CampaignStateEnum.ACTIVE */.k.ACTIVE;
    });
    var dailyDeals = activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.find(function(c) {
        return (c === null || c === void 0 ? void 0 : c.id) === campaign_ids/* CampaignIdEnum.DAILY_DEALS_ID */.pw.DAILY_DEALS_ID;
    });
    var inactiveCampaignTargetDate = (campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start) ? Number((campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start)) : undefined;
    var headerImage = (campaign === null || campaign === void 0 ? void 0 : (ref = campaign.banners) === null || ref === void 0 ? void 0 : ref.length) ? ((ref1 = campaign.banners.find(function(banner) {
        return (banner === null || banner === void 0 ? void 0 : banner.type.toUpperCase()) === deals_header_types/* CampaignBannerTypeEnum.BANNER_LOGO_BIG */.E.BANNER_LOGO_BIG;
    })) === null || ref1 === void 0 ? void 0 : ref1.imageUrl) || "" : null;
    return {
        activeCampaigns: activeCampaigns,
        campaign: campaign,
        dailyDeals: dailyDeals,
        headerImage: headerImage,
        inactiveCampaignTargetDate: inactiveCampaignTargetDate,
        isActiveCampaign: isActiveCampaign
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/deals-page/index.tsx



















var CampaignPageComponent = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useCampaignPageQuery(route === null || route === void 0 ? void 0 : route.variables, true), campaignData = ref.data;
    var location = (0,react_router/* useLocation */.TH)();
    var categoryPathSearchParam = querystring.decode((location === null || location === void 0 ? void 0 : location.search) ? location.search.substring(1) : "").category;
    var categoryPath = typeof categoryPathSearchParam === "string" ? categoryPathSearchParam.split("|") : [];
    var adsConfig = {
        pageOptions: {
            pageType: "deals",
            categoryPath: categoryPath
        },
        formats: [
            "panorama_1_wde",
            "panorama_1",
            "welcome_page_wde",
            "welcome_page"
        ]
    };
    var ref1 = extractCampaignData(campaignData), isActiveCampaign = ref1.isActiveCampaign, activeCampaigns = ref1.activeCampaigns, campaign = ref1.campaign, dailyDeals = ref1.dailyDeals, inactiveCampaignTargetDate = ref1.inactiveCampaignTargetDate;
    var initialSearchState = {
        sortType: shared_types/* ProductSortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */.mJ.PRODUCT_POPULARITY_TOTAL,
        page: 1,
        filters: {
            priceDropPercent: shared_types/* PriceDropPercent.PERCENT_10 */.E1.PERCENT_10
        }
    };
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        adsConfig: adsConfig
    }, /*#__PURE__*/ react.createElement(deals_context/* DealsStateProvider */.x9, {
        campaignData: campaignData
    }, /*#__PURE__*/ react.createElement(search_context/* SearchStateProvider */.jn, {
        initState: initialSearchState,
        useSearchQuery: useDealsQuery/* useDealsQuery */.N
    }, /*#__PURE__*/ react.createElement(tracking_context/* TrackingFunctionsProvider */.qK, {
        searchPageType: shared_types/* SearchPageType.DEALS */.zh.DEALS
    }, /*#__PURE__*/ react.createElement(DealsHeader, {
        breadcrumbs: /*#__PURE__*/ react.createElement(DealsBreadcrumbs, null),
        searchPageType: shared_types/* SearchPageType.DEALS */.zh.DEALS
    }), isActiveCampaign ? /*#__PURE__*/ react.createElement(content_wrapper/* ContentWrapper */.v, {
        searchPageType: shared_types/* SearchPageType.DEALS */.zh.DEALS
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(CampaignInactive, {
        targetDate: inactiveCampaignTargetDate,
        campaign: campaign,
        dailyDeals: dailyDeals
    }), /*#__PURE__*/ react.createElement(StyledOngoingCampaignsInfo, {
        title: t("campaigns", "themes.ongoing-campaigns"),
        campaigns: activeCampaigns
    }))), /*#__PURE__*/ react.createElement(ActiveCampaignArticle, null))));
};
/* harmony default export */ var deals_page = (CampaignPageComponent);


/***/ }),

/***/ 78082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ TabAnchor)
/* harmony export */ });
var TabAnchor;
(function(TabAnchor) {
    TabAnchor["PRODUCTS"] = "#products";
    TabAnchor["CATEGORIES"] = "#categories";
    TabAnchor["TESTS"] = "#tests-and-guides";
})(TabAnchor || (TabAnchor = {}));


/***/ }),

/***/ 72418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": () => (/* binding */ SearchMode),
  "Z": () => (/* binding */ container)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/components/entity-search/qeuries/query.graphql
var query_graphql = __webpack_require__(40877);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/components/entity-search/qeuries/use-entity-search-query.ts


var useEntitySearchQuery = function(searchQuery, stores, products) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (query_graphql_default()),
        queryKey: [
            "entity-search"
        ],
        variables: {
            query: searchQuery,
            stores: stores,
            products: products
        }
    });
};

;// CONCATENATED MODULE: ./src/components/entity-search/container.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var SearchMode;
(function(SearchMode) {
    SearchMode["PRODUCTS"] = "products";
    SearchMode["SHOPS"] = "shops";
})(SearchMode || (SearchMode = {}));
var SearchContainer = function(param) {
    var query = param.query, onSearchResultFound = param.onSearchResultFound, disableScrollToTop = param.disableScrollToTop, render = param.render, searchMode = param.searchMode;
    var ref, ref1;
    var ref2 = _slicedToArray((0,react.useState)(""), 2), searchQuery = ref2[0], setSearchQuery = ref2[1];
    var mounted = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        debounce_default()(function() {
            setSearchQuery(query);
        }, 300);
    }, [
        query
    ]);
    var ref3 = useEntitySearchQuery(searchQuery, Boolean(searchMode === "shops"), Boolean(searchMode === "products")), data = ref3.data, isLoading = ref3.isLoading;
    (0,react.useEffect)(function() {
        if (!disableScrollToTop) {
            // Reset scroll position for small devices
            if ( true && window.innerWidth <= 620) {
                window.scrollTo(0, 0);
            }
        }
    }, [
        disableScrollToTop
    ]);
    (0,react.useEffect)(function() {
        setSearchQuery(query);
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        var ref;
        onSearchResultFound === null || onSearchResultFound === void 0 ? void 0 : onSearchResultFound(data === null || data === void 0 ? void 0 : (ref = data.newSearch) === null || ref === void 0 ? void 0 : ref.results);
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.newSearch) === null || ref === void 0 ? void 0 : ref.results,
        onSearchResultFound
    ]);
    (0,react.useEffect)(function() {
        mounted.current = true;
    }, []);
    return render(data === null || data === void 0 ? void 0 : (ref1 = data.newSearch) === null || ref1 === void 0 ? void 0 : ref1.results, isLoading);
};
/* harmony default export */ var container = (SearchContainer);


/***/ }),

/***/ 98473:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": () => (/* binding */ SearchBox)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/entity-search/container.tsx + 1 modules
var container = __webpack_require__(72418);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/entity-search/components/selectable/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      border-radius: 5px;\n\n      > a {\n        background: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SearchSelectable = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchSelectable",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject(), base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.maybeBlue700, 0.2));
}, function(p) {
    return p.theme.colors.base100;
});

;// CONCATENATED MODULE: ./src/components/entity-search/components/selectable/selectable.tsx


var Selectable = function(props) {
    var isSelected = String(props.selected) === String(props.id);
    return /*#__PURE__*/ react.createElement(SearchSelectable, {
        selected: isSelected,
        role: "option",
        "aria-selected": isSelected,
        "data-selected": isSelected,
        "data-query": props.query,
        "data-selection-id": props.id,
        id: "selection".concat(props.id)
    }, props.children);
};
/* harmony default export */ var selectable = (Selectable);

// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(24562);
// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(91441);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(89975);
;// CONCATENATED MODULE: ./src/components/entity-search/components/item/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  height: 24px;\n  img {\n    height: 16px;\n    width: auto;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  .pj-ui-product-list-item--grid:hover &,\n  .pj-ui-product-row:hover & {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: 5px;\n  vertical-align: -2px;\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledListItem = (0,styled_components_browser_esm["default"])(list_item/* ListItem */.H).withConfig({
    displayName: "StyledListItem",
    componentId: "sc-0-0"
})({
    "&&": {
        img: {
            marginRight: "10px"
        }
    }
});
var StoreLogo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-1"
})(styles_templateObject());
var OutlinkCallToAction = styled_components_browser_esm["default"].span.withConfig({
    displayName: "OutlinkCallToAction",
    componentId: "sc-0-2"
})(styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var OutlinkIcon = (0,styled_components_browser_esm["default"])(outgoing_link/* IconOutgoingLink */.v).withConfig({
    displayName: "OutlinkIcon",
    componentId: "sc-0-3"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/entity-search/components/item/item.tsx






var SearchItem = function(param) {
    var item = param.item, onSelect = param.onSelect;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var onClickHandler = function(e) {
        if (onSelect) {
            e.preventDefault();
            onSelect(item);
        }
    };
    switch(item.__typename){
        case "Product":
            var ref, ref1, ref2, ref3;
            return /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                onClick: onClickHandler,
                name: item.name,
                link: item.pathName,
                price: item.priceSummary.regular,
                subtitle: (ref = item.category) === null || ref === void 0 ? void 0 : ref.name,
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: item.name,
                    src: item.media.first
                }),
                rating: (ref1 = item.aggregatedRating) === null || ref1 === void 0 ? void 0 : ref1.score,
                ratingCount: (ref2 = item.aggregatedRating) === null || ref2 === void 0 ? void 0 : ref2.count,
                storesCount: item.priceSummary.count || undefined,
                storesCountText: t("campaigns", "item.sold-by-n-stores", {
                    n: ((ref3 = item.priceSummary.count) === null || ref3 === void 0 ? void 0 : ref3.toString()) || ""
                }),
                showDivider: true
            });
        case "Store":
            {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: item.pathName,
                    onClick: onClickHandler,
                    image: item.hasLogo && item.logo && /*#__PURE__*/ react.createElement(StoreLogo, {
                        storeId: item.id,
                        name: item.name,
                        hasImage: item.hasLogo,
                        featured: true
                    }),
                    showArrow: true
                });
            }
        default:
            return null;
    }
};
/* harmony default export */ var item = (/*#__PURE__*/(0,react.memo)(SearchItem));

// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
;// CONCATENATED MODULE: ./src/components/entity-search/styles.ts
function entity_search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function entity_search_styles_templateObject() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: ",
        " 10px;\n"
    ]);
    entity_search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function entity_search_styles_templateObject1() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: 10px;\n"
    ]);
    entity_search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  background: white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = entity_search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var NoResults = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResults",
    componentId: "sc-0-0"
})(entity_search_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShowAllSelectable = (0,styled_components_browser_esm["default"])(selectable).withConfig({
    displayName: "ShowAllSelectable",
    componentId: "sc-0-1"
})(entity_search_styles_templateObject1());
var ProductListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListBox",
    componentId: "sc-0-2"
})(styles_templateObject2(), function(p) {
    return p.simple ? "0" : "10px";
});
var CategoryListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryListBox",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.simple ? "0" : "10px";
});
var NoResultContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResultContainer",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var SpinnerContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SpinnerContainer",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/components/entity-search/render.tsx







var Style;
(function(Style) {
    Style["SIMPLE"] = "simple";
    Style["RICH"] = "rich";
    Style["NONE"] = "none";
})(Style || (Style = {}));
var SearchPage = function(props) {
    var ref;
    var query = props.query, onEnterSearchMenu = props.onEnterSearchMenu, onExitSearchMenu = props.onExitSearchMenu, onSelect = props.onSelect, results = props.results, styling = props.styling, isLoading = props.isLoading;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement("div", {
        className: "pj-ui-search" // Shop search has dependency on this className
        ,
        onMouseEnter: onEnterSearchMenu,
        onMouseLeave: onExitSearchMenu,
        onTouchStart: onEnterSearchMenu,
        onTouchEnd: onExitSearchMenu
    }, isLoading && /*#__PURE__*/ react.createElement(SpinnerContainer, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: true,
        position: "none",
        size: 24
    })), (results === null || results === void 0 ? void 0 : results.products) && results.products.nodes && ((ref = results.products.nodes) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(ProductListBox, {
        className: "pj-ui-search--products",
        simple: styling === "simple",
        role: "listbox"
    }, results.products.nodes.map(function(product) {
        return /*#__PURE__*/ react.createElement(selectable, {
            key: product.id,
            id: product.id
        }, /*#__PURE__*/ react.createElement(item, {
            item: product,
            onSelect: onSelect
        }));
    }))), (results === null || results === void 0 ? void 0 : results.shops) && results.shops.nodes && results.shops.nodes.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(ProductListBox, {
        className: "pj-ui-search--products",
        simple: styling === "simple",
        role: "listbox"
    }, results.shops.nodes.map(function(store) {
        return /*#__PURE__*/ react.createElement(selectable, {
            key: store.id,
            id: store.id
        }, /*#__PURE__*/ react.createElement(item, {
            item: store,
            onSelect: onSelect
        }));
    }))), Boolean((results === null || results === void 0 ? void 0 : results.products) && results.products.nodes && results.products.nodes.length <= 0 || (results === null || results === void 0 ? void 0 : results.shops) && (results === null || results === void 0 ? void 0 : results.shops.nodes) && (results === null || results === void 0 ? void 0 : results.shops.nodes.length) <= 0) && /*#__PURE__*/ react.createElement(NoResults, null, /*#__PURE__*/ react.createElement("span", null, t("search", "no-search-results.title", {
        query: query
    }))));
};
/* harmony default export */ var render = (SearchPage);

;// CONCATENATED MODULE: ./src/components/entity-search/search.tsx



var Search = function(param) {
    var query = param.query, showAllResults = param.showAllResults, onSelect = param.onSelect, styling = param.styling, onItemClick = param.onItemClick, onEnter = param.onEnter, onExit = param.onExit, onSearchResultFound = param.onSearchResultFound, _disableScrollToTop = param.disableScrollToTop, disableScrollToTop = _disableScrollToTop === void 0 ? false : _disableScrollToTop, _inputMinLength = param.inputMinLength, inputMinLength = _inputMinLength === void 0 ? 2 : _inputMinLength, searchMode = param.searchMode;
    if (query.length < inputMinLength) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(container/* default */.Z, {
        query: query,
        disableScrollToTop: disableScrollToTop,
        onSearchResultFound: onSearchResultFound,
        searchMode: searchMode,
        render: function(results, isLoading) {
            return /*#__PURE__*/ react.createElement(render, {
                showAllResults: showAllResults,
                results: results,
                query: query,
                onSelect: onSelect,
                styling: styling,
                onItemClick: onItemClick,
                onEnterSearchMenu: onEnter,
                onExitSearchMenu: onExit,
                isLoading: isLoading
            });
        }
    });
};
/* harmony default export */ var entity_search_search = (Search);

// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
;// CONCATENATED MODULE: ./src/components/entity-search/search-box/components/related-products/styles.ts
function related_products_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function related_products_styles_templateObject() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 4;\n  box-shadow: ",
        ";\n"
    ]);
    related_products_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function related_products_styles_templateObject1() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    related_products_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function related_products_styles_templateObject2() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    related_products_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n          top: 37px;\n        "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n      ",
        ";\n      top: 47px;\n\n      ",
        ", ",
        " {\n        padding: 0 ",
        ";\n      }\n\n      ",
        "\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n    background: ",
        ";\n    border-radius: 4px;\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = related_products_styles_taggedTemplateLiteral([
        "\n    min-height: auto;\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var relatedProductsTitleFontSize = (0,base/* remCalc */.vR)(15);
var boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var relatedProductsOverlayStyles = (0,styled_components_browser_esm.css)(related_products_styles_templateObject(), boxShadowStyle);
var RelatedProductsTitle = styled_components_browser_esm["default"].h5.withConfig({
    displayName: "RelatedProductsTitle",
    componentId: "sc-0-0"
})(related_products_styles_templateObject1(), relatedProductsTitleFontSize, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RelatedProductsSubTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RelatedProductsSubTitle",
    componentId: "sc-0-1"
})(related_products_styles_templateObject2(), function(p) {
    return p.theme.text.quaternary;
});
var RelatedProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedProducts",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject5(), props.theme.colors.base0, props.relatedProductsAsOverlay && (0,styled_components_browser_esm.css)(styles_templateObject4(), relatedProductsOverlayStyles, RelatedProductsTitle, RelatedProductsSubTitle, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(styles_templateObject3())));
});
var ProductRow = (0,styled_components_browser_esm["default"])(product_row/* default */.Z).withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject7(), base/* media.mediumDown */.BC.mediumDown(_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100)));
});

;// CONCATENATED MODULE: ./src/components/entity-search/search-box/components/related-products/index.tsx




var related_products_RelatedProducts = function(param) {
    var relatedProducts = param.relatedProducts, relatedProductsAsOverlay = param.relatedProductsAsOverlay, onSelect = param.onSelect, showNewComparePageLayout = param.showNewComparePageLayout;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(RelatedProducts, {
        relatedProductsAsOverlay: relatedProductsAsOverlay
    }, /*#__PURE__*/ react.createElement(RelatedProductsTitle, null, t("product", "recommendations.similar-products")), /*#__PURE__*/ react.createElement(RelatedProductsSubTitle, null, t("compare", "related-products.add")), relatedProducts.map(function(relatedProduct) {
        var onClickHandler = function(e) {
            e.preventDefault();
            onSelect(relatedProduct);
        };
        return /*#__PURE__*/ react.createElement(ProductRow, {
            key: "related-product-".concat(relatedProduct.id),
            onClick: onClickHandler,
            name: relatedProduct.name,
            price: relatedProduct.price,
            image: relatedProduct.imageUrl && /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                name: relatedProduct.name,
                src: relatedProduct.imageUrl
            }),
            showDivider: true,
            showNewComparePageLayout: showNewComparePageLayout
        });
    }));
};
/* harmony default export */ var related_products = (related_products_RelatedProducts);

;// CONCATENATED MODULE: ./src/components/entity-search/search-box/styles.ts
function search_box_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function search_box_styles_templateObject() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      border-bottom: none;\n      border-radius: 5px 5px 0px 0px;\n      * {\n        border-radius: 5px 5px 0px 0px;\n      }\n    "
    ]);
    search_box_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject1() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    border: ",
        "px solid\n      ",
        ";\n    overflow: hidden;\n    border-bottom: ",
        "px solid\n      ",
        ";\n    border-radius: 5px;\n\n    ",
        "\n  "
    ]);
    search_box_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject2() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      position: absolute;\n    "
    ]);
    search_box_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject3() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n        border: 1px solid ",
        ";\n        border-top: none;\n      "
    ]);
    search_box_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject4() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          top: ",
        ";\n        "
    ]);
    search_box_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function search_box_styles_templateObject5() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          top: ",
        "px;\n        "
    ]);
    search_box_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          top: {searchHeight}px;\n        "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      left: 0;\n      right: 0;\n      border: none;\n      border-top: none;\n      z-index: 10;\n      box-shadow: ",
        ";\n\n      ",
        "\n\n      ",
        ";\n\n      ",
        ";\n\n      ",
        ";\n    "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n    ",
        "\n    background: ",
        ";\n    border-radius: 0px 0px 5px 5px;\n    overflow: hidden;\n    text-align: left;\n    box-shadow: ",
        ";\n\n    ",
        ";\n\n    .pj-ui-search--products {\n      padding-top: 0;\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n\n          ",
        " {\n            border-bottom: 1px solid ",
        ";\n            \n          }\n\n          ",
        " {\n            border: none;\n            box-shadow: none;\n          }\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = search_box_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var searchHeight = base/* layout.searchBar.height.desktop.value */.bK.searchBar.height.desktop.value;
var searchHeightMobile = base/* layout.searchBar.height.mobile.value */.bK.searchBar.height.mobile.value;
var searchBorderWidth = base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth;
var styles_boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var SearchInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(search_box_styles_templateObject1(), base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, props.searchIsOpen && (0,styled_components_browser_esm.css)(search_box_styles_templateObject()));
});
var SearchResult = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchResult",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject9(), props.useAbsolute && (0,styled_components_browser_esm.css)(search_box_styles_templateObject2()), props.theme.colors.base0, styles_boxShadowStyle, props.showFloatingResult && (0,styled_components_browser_esm.css)(styles_templateObject7(), styles_boxShadowStyle, props.searchIsOpen && (0,styled_components_browser_esm.css)(search_box_styles_templateObject3(), props.theme.colors.maybeBlue700), base/* media.smallOnly */.BC.smallOnly(search_box_styles_templateObject4(), props.showNewComparePageLayout ? "".concat(searchHeightMobile + searchBorderWidth * 2, "px") : "".concat(searchHeightMobile, "px")), base/* media.mediumOnly */.BC.mediumOnly(search_box_styles_templateObject5(), searchHeight + searchBorderWidth * 2), base/* media.largeUp */.BC.largeUp(styles_templateObject6())), base/* media.mediumDown */.BC.mediumDown(styles_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
});
var SearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchWrapper",
    componentId: "sc-0-2"
})(_templateObject10());
var styles_Search = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Search",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject12(), base/* media.mediumDown */.BC.mediumDown(_templateObject11(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, SearchInput, props.theme.colors.maybeBlue700, SearchResult)));
});

;// CONCATENATED MODULE: ./src/components/entity-search/search-box/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var INPUT_MIN_LENGTH = 2;
var SearchBox = function(param) {
    var _showNewComparePageLayout = param.showNewComparePageLayout, showNewComparePageLayout = _showNewComparePageLayout === void 0 ? false : _showNewComparePageLayout, _relatedProductsAsOverlay = param.relatedProductsAsOverlay, relatedProductsAsOverlay = _relatedProductsAsOverlay === void 0 ? false : _relatedProductsAsOverlay, _showFloatingResult = param.showFloatingResult, showFloatingResult = _showFloatingResult === void 0 ? true : _showFloatingResult, focusOnMount = param.focusOnMount, placeholder = param.placeholder, onSelect = param.onSelect, relatedProducts = param.relatedProducts, searchMode = param.searchMode, _useAbsolute = param.useAbsolute, useAbsolute = _useAbsolute === void 0 ? false : _useAbsolute;
    var searchRef = (0,react.useRef)(null);
    var searchInputRef = (0,react.useRef)(null);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(""), 2), inputValue = ref[0], setInputValueState = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(""), 2), search = ref1[0], setSearchState = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), hasResultsState = ref2[0], setHasResultsState = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)([]), 2), results = ref3[0], setResultsState = ref3[1];
    var resetSearch = function() {
        setSearchState("");
        setHasResultsState(false);
    };
    var handleOnChange = (0,react.useCallback)(function(searchTerm) {
        setSearchState(searchTerm);
        setHasResultsState(false);
    }, []);
    var handleOnFocus = (0,react.useCallback)(function(searchTerm) {
        if (searchTerm.length >= INPUT_MIN_LENGTH) {
            setSearchState(searchTerm);
            setHasResultsState(true);
        }
    }, []);
    var setInputValue = (0,react.useCallback)(function(input) {
        setInputValueState(input);
    }, []);
    var handleOnSelect = (0,react.useCallback)(function(product) {
        setInputValueState("");
        resetSearch();
        return onSelect(product);
    }, [
        onSelect
    ]);
    var handleSearchResultFound = (0,react.useCallback)(function() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        var ref;
        setHasResultsState(true);
        var ref1;
        setResultsState((ref1 = (ref = items[0]) === null || ref === void 0 ? void 0 : ref.hits) !== null && ref1 !== void 0 ? ref1 : []);
    }, []);
    var handleKeyDown = (0,react.useCallback)(function(e) {
        if (e.key === "Escape") {
            resetSearch();
        }
    }, []);
    var handleClickOutside = (0,react.useCallback)(function(e) {
        if (e.target && searchRef.current && !searchRef.current.contains(e.target)) {
            resetSearch();
        }
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("click", handleClickOutside);
        if (focusOnMount && searchInputRef.current) {
            var inputElement = searchInputRef.current.querySelector("input[type=text]");
            if (inputElement) {
                inputElement.focus();
            }
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("click", handleClickOutside);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var searchIsOpen = inputValue.length >= INPUT_MIN_LENGTH && search !== "";
    var hasResults = hasResultsState && search !== "" && results && results.length > 0;
    return /*#__PURE__*/ react.createElement(SearchWrapper, {
        ref: searchRef
    }, /*#__PURE__*/ react.createElement(styles_Search, {
        showNewComparePageLayout: showNewComparePageLayout
    }, /*#__PURE__*/ react.createElement(SearchInput, {
        ref: searchInputRef,
        searchIsOpen: searchIsOpen
    }, /*#__PURE__*/ react.createElement(inputs/* Search */.ol, {
        key: "search",
        placeholder: placeholder || t("search", "search-products.placeholder"),
        hasResults: hasResults,
        onChange: handleOnChange,
        onFocus: handleOnFocus,
        inputValue: inputValue,
        setInputValue: setInputValue
    })), /*#__PURE__*/ react.createElement(SearchResult, {
        searchIsOpen: searchIsOpen,
        showFloatingResult: showFloatingResult,
        showNewComparePageLayout: showNewComparePageLayout,
        useAbsolute: useAbsolute
    }, /*#__PURE__*/ react.createElement(entity_search_search, {
        query: search,
        onSelect: handleOnSelect,
        showAllResults: false,
        styling: Style.NONE,
        disableScrollToTop: true,
        onSearchResultFound: handleSearchResultFound,
        inputMinLength: INPUT_MIN_LENGTH,
        searchMode: searchMode
    }))), relatedProducts && Boolean(relatedProducts.length) && !hasResults && Boolean(!searchIsOpen) && /*#__PURE__*/ react.createElement(related_products, {
        relatedProducts: relatedProducts,
        relatedProductsAsOverlay: relatedProductsAsOverlay,
        onSelect: handleOnSelect,
        showNewComparePageLayout: showNewComparePageLayout
    }));
};


/***/ }),

/***/ 83068:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ FeaturedArticle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-group/index.js + 1 modules
var campaign_group = __webpack_require__(13066);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
;// CONCATENATED MODULE: ./src/components/featured-article/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n    padding-right: ",
        ";\n    flex: 1 0 70%;\n      max-width: 70%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 0 640px;\n    max-width: 640px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  flex: 1 0 100%;\n  max-width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      flex: 1 0 100%;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 100%;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin-bottom: 1rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 185px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StyledArticle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-0"
})(_templateObject2(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300, base/* media.mediumUp */.BC.mediumUp(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150), base/* media.largeUp */.BC.largeUp(_templateObject1()));
var RelatedArticleContainer = styled_components_browser_esm["default"].section.withConfig({
    displayName: "RelatedArticleContainer",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject3()), function(p) {
    return p.fullWidth && (0,styled_components_browser_esm.css)(_templateObject4());
});
var StyledFeaturedArticle = styled_components_browser_esm["default"].section.withConfig({
    displayName: "StyledFeaturedArticle",
    componentId: "sc-0-2"
})(_templateObject6(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300);
var RelatedArticleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedArticleWrapper",
    componentId: "sc-0-3"
})(_templateObject7());
var StyledCardMedia = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "StyledCardMedia",
    componentId: "sc-0-4"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/article/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-bottom: 1.2rem;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.6rem;\n  line-height: 1.4;\n  margin: 0 0 1rem;\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    h4 {margin-bottom: 1.4rem;}\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  color: ",
        ";\n\n  figure {\n    margin-bottom: 1rem;\n    img {\n      display: block;\n      margin: 0 auto;\n      max-width: 100%;\n    }\n    figcaption {\n      color: ",
        ";\n      text-align: right;\n    }\n  }\n  ",
        " {\n    font-size: 1.6rem;\n  }\n  h2 {\n    font-size: 1.3rem;\n  }\n  h3 {\n    font-size: 1.15rem;\n  }\n  h4 {\n    margin-bottom: 1rem;\n  }\n  ol,\n  ul {\n    list-style-position: inside;\n    line-height: 1.6;\n  }\n  p {\n    line-height: 1.6;\n  }\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n  .caption {\n    text-align: right;\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  font-weight: 600;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledArticleHeading = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "StyledArticleHeading",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* media.largeUp */.BC.largeUp(styles_templateObject()));
var styles_StyledArticle = styled_components_browser_esm["default"].article.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-1"
})(styles_templateObject3(), function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.text.secondary;
}, StyledArticleHeading, function(p) {
    return p.theme.text.linkExternal;
}, base/* media.largeUp */.BC.largeUp(styles_templateObject2()));
var Preamble = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Preamble",
    componentId: "sc-0-2"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/components/article/article-heading.tsx


var ArticleHeading = function(param) {
    var title = param.title, _embedded = param.embedded, embedded = _embedded === void 0 ? false : _embedded;
    return embedded ? /*#__PURE__*/ react.createElement(StyledArticleHeading, {
        as: "h2"
    }, title) : /*#__PURE__*/ react.createElement(StyledArticleHeading, null, title);
};

// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/components/article/article.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Article = function(_param) {
    var _embedded = _param.embedded, embedded = _embedded === void 0 ? true : _embedded, props = _objectWithoutProperties(_param, [
        "embedded"
    ]);
    return /*#__PURE__*/ react.createElement(styles_StyledArticle, null, props.imageUrl && /*#__PURE__*/ react.createElement("figure", null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        src: props.imageUrl,
        alt: props.imageCaption || ""
    })), props.imageCaption && /*#__PURE__*/ react.createElement("figcaption", null, props.imageCaption)), /*#__PURE__*/ react.createElement(ArticleHeading, {
        title: props.title,
        embedded: embedded
    }), props.preamble && /*#__PURE__*/ react.createElement(Preamble, null, props.preamble), props.body && /*#__PURE__*/ react.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: props.body
        }
    }), props.byline && /*#__PURE__*/ react.createElement("span", null, props.byline));
};

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/areas/expert/styles.ts
var styles = __webpack_require__(96674);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/featured-article/related-article.tsx








var RelatedArticle = function(param) {
    var article = param.article, _preambleMaxLength = param.preambleMaxLength, preambleMaxLength = _preambleMaxLength === void 0 ? 80 : _preambleMaxLength;
    return /*#__PURE__*/ react.createElement(card.Card, null, /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: article.pathName,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.RELATED_ARTICLE */.U.RELATED_ARTICLE,
                    nextPage: article.pathName
                });
            }
        }
    }, article.imageUrl && /*#__PURE__*/ react.createElement(StyledCardMedia, null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        alt: article.title,
        src: article.imageUrl,
        height: 124
    }))), /*#__PURE__*/ react.createElement(card.CardContent, null, /*#__PURE__*/ react.createElement(styles/* CardTitle */.ll, null, article.title), article.preamble && /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        container: "p"
    }, formatPreamble(article.preamble, preambleMaxLength)))));
};
function formatPreamble(str, maxLength) {
    return str && str.length > maxLength ? "".concat(str.substr(0, str.substr(0, maxLength).lastIndexOf(" ")).trim(), "\xa0…") : str;
}

;// CONCATENATED MODULE: ./src/components/featured-article/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var FeaturedArticle = function(param) {
    var article = param.article, _embedded = param.embedded, embedded = _embedded === void 0 ? true : _embedded, _related = param.related, related = _related === void 0 ? [] : _related;
    var ref;
    var articleId = article ? article.id : null;
    var relatedArticles = (article && article.related && article.related.articles ? related.concat(article.related.articles) : related).filter(Boolean).filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== articleId;
    }).sort(function(a, b) {
        return new Date((b === null || b === void 0 ? void 0 : b.publishedAt) || "1971-1-1").getTime() - new Date((a === null || a === void 0 ? void 0 : a.publishedAt) || "1971-1-1").getTime();
    });
    return /*#__PURE__*/ react.createElement(StyledFeaturedArticle, null, !!article && /*#__PURE__*/ react.createElement(StyledArticle, null, /*#__PURE__*/ react.createElement(Article, _extends({}, article, {
        embedded: embedded
    }))), /*#__PURE__*/ react.createElement(RelatedArticleContainer, {
        fullWidth: !article
    }, /*#__PURE__*/ react.createElement(RelatedArticleWrapper, null, relatedArticles.map(function(item) {
        return /*#__PURE__*/ react.createElement(RelatedArticle, {
            key: item.id,
            article: item
        });
    })), (article === null || article === void 0 ? void 0 : (ref = article.related) === null || ref === void 0 ? void 0 : ref.campaign) && /*#__PURE__*/ react.createElement(campaign_group/* default */.Z, {
        campaigns: [
            article.related.campaign
        ]
    })));
};


/***/ }),

/***/ 25676:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": () => (/* reexport */ Grid)
});

// UNUSED EXPORTS: GridRow

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        margin-bottom: ",
        ";\n        margin-right: ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  /* Basic fallback for IE11 */\n\n  display: flex;\n  flex-wrap: wrap;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-gap: ",
        ";\n\n  > * {\n    /* grid-gap fallback for IE11 */\n    ",
        "\n\n    @supports (display: grid) {\n      margin-bottom: 0;\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* stylelint-disable declaration-block-no-duplicate-properties */ var Grid = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Grid",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.columnTemplate || "repeat(".concat(props.columnCount || "auto-fill", ", minmax(").concat(props.columnMinWidth || "auto", ", ").concat(props.columnMaxWidth || "1fr", "))");
}, function(props) {
    return props.gap || "10px";
}, function(props) {
    return props.gap && (0,styled_components_browser_esm.css)(_templateObject(), props.gap, props.gap);
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid-row.js
function grid_row_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function grid_row_templateObject() {
    var data = grid_row_taggedTemplateLiteral([
        "\n  grid-column: 1 / -1;\n  grid-row-start: ",
        ";\n\n  /* Fallback for browsers without grid support */\n  flex: 1 0 100%;\n  order: 1;\n"
    ]);
    grid_row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GridRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridRow",
    componentId: "sc-0-0"
})(grid_row_templateObject(), function(props) {
    return props.row;
});
var number = (prop_types_default()).number, node = (prop_types_default()).node;
GridRow.propTypes = {
    children: node,
    row: number
};
GridRow.defaultProps = {
    children: undefined,
    row: 1
};

;// CONCATENATED MODULE: ./src/components/flexible-grid/index.ts





/***/ }),

/***/ 91441:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40889);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var ListItem = function(param) {
    var children = param.children, name = param.name, link = param.link, image = param.image, callToActionText = param.callToActionText, showArrow = param.showArrow, showBackArrow = param.showBackArrow, _onClick = param.onClick, onClick = _onClick === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT : _onClick, className = param.className, isExternal = param.isExternal, linkAttributes = param.linkAttributes, dataTest = param["data-test"], disabled = param.disabled;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, _extends({
        onClick: onClick,
        className: className,
        to: link,
        isExternal: isExternal
    }, linkAttributes || {}, {
        "data-test": dataTest,
        disabled: disabled
    }), showBackArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LeftArrow */ .IT, null), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, null, image), children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, null, name), callToActionText && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .Jd, null, callToActionText), showArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightArrow */ .UV, null));
};


/***/ }),

/***/ 40889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Jd": () => (/* binding */ CallToAction),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "VG": () => (/* binding */ Name)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37456);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93345);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21541);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      opacity: 0.5;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  min-height: 48px;\n  padding: ",
        " ",
        ";\n  text-align: left;\n  display: flex;\n  align-items: center;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 50%;\n  margin-left: ",
        ";\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var padding = src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var ListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, padding, function(props) {
    return props.theme.bg.secondary;
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), padding);
var Name = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.TitleSmallText).withConfig({
    displayName: "Name",
    componentId: "sc-0-2"
})(_templateObject3());
var CallToAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "CallToAction",
    componentId: "sc-0-3"
})(_templateObject4(), function(props) {
    return props.theme.text.callToAction;
}, padding);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs({
    size: 20
}).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject5(), padding);
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-5"
})(_templateObject6(), padding);


/***/ }),

/***/ 2869:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ modal)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-modal@3.8.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(5870);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
;// CONCATENATED MODULE: ./src/components/modal/index.styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 90vw;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 90vw;\n      padding: ",
        ";\n      margin-top: ",
        "px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          padding: ",
        " 0;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      margin: 0;\n      padding: $padding-wrapper 0;\n\n      ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        ";\n    background: #fff;\n    border-radius: ",
        ";\n    overflow: hidden;\n    outline: 0;\n    display: flex;\n    flex-flow: row wrap;\n    position: absolute;\n    margin: ",
        "px auto;\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    h1 {\n      font-size: 2.2rem;\n    }\n    > h1,\n    > h2,\n    > h3,\n    > h4,\n    > h5,\n    > h6 {\n      &:first-child {\n        margin-top: 0;\n        margin-bottom: 0.5em;\n        line-height: 1.2em;\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0 ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0 ",
        ";\n  max-height: 80vh;\n  overflow-y: auto;\n\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  width: 40px;\n  height: 40px;\n  user-select: none;\n  cursor: pointer;\n  border: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm["default"])((lib_default())).withConfig({
    displayName: "Modal",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.borderRadius */.bK.borderRadius, base/* layout.headerHeight.desktop.value */.bK.headerHeight.desktop.value, base/* media.mediumDown */.BC.mediumDown(_templateObject()), base/* media.smallOnly */.BC.smallOnly(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.headerHeight.mobile.value */.bK.headerHeight.mobile.value / 2), props.$verticalScroll && (0,styled_components_browser_esm.css)(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050)));
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject5());
var Viewport = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Viewport",
    componentId: "sc-0-2"
})(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var CloseButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-3"
})(_templateObject8(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/modal/modal.tsx







var APP_ROOT_ID = "root";
var MODAL_ROOT_ID = "root-modal";
var getModalRoot = function() {
    return document.getElementById(MODAL_ROOT_ID);
};
var modal_Modal = function(props) {
    react.useEffect(function() {
        lib_default().setAppElement("#".concat(APP_ROOT_ID));
    }, []);
    var children = props.children, className = props.className, dataTest = props.dataTest, id = props.id, _isOpen = props.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, onRequestClose = props.onRequestClose, _shouldShowCloseIcon = props.shouldShowCloseIcon, shouldShowCloseIcon = _shouldShowCloseIcon === void 0 ? true : _shouldShowCloseIcon, _shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? true : _shouldCloseOnOverlayClick, _verticalScroll = props.verticalScroll, verticalScroll = _verticalScroll === void 0 ? false : _verticalScroll, _width = props.width, width = _width === void 0 ? "auto" : _width;
    var current = (0,es/* useSelector */.v9)(function(state) {
        return state.modal.current;
    });
    return /*#__PURE__*/ react.createElement(Modal, {
        id: id,
        className: className,
        isOpen: isOpen || !!current && current === id,
        onRequestClose: onRequestClose,
        parentSelector: getModalRoot,
        $verticalScroll: verticalScroll,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        style: {
            content: {
                width: width
            },
            overlay: {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height: "100%",
                width: "100%",
                background: base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(base/* colors.lightTheme.base700 */.O9.lightTheme.base700, "0.8"),
                overflow: "auto",
                zIndex: zindex/* zindex.modal */.Y.modal,
                overflowY: "scroll",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                justifyContent: "center"
            }
        }
    }, /*#__PURE__*/ react.createElement(Wrapper, {
        "data-test": dataTest
    }, verticalScroll ? /*#__PURE__*/ react.createElement(Viewport, null, children) : children, shouldShowCloseIcon && /*#__PURE__*/ react.createElement(CloseButton, {
        variant: "icon",
        onClick: function() {
            if (onRequestClose) onRequestClose();
        },
        tabIndex: 0,
        icon: /*#__PURE__*/ react.createElement(icon_close.IconClose, null),
        "data-test": "ModalDialogCloseButton"
    })));
};
/* harmony default export */ var modal = (modal_Modal);


/***/ }),

/***/ 49192:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ NumberPagination)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-items.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function notNull(item) {
    return item !== null;
}
function getPrevPageItem(currentPage, alwaysShowStepButtons) {
    if (currentPage === 1 && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "prev",
        pageNumber: currentPage - 1,
        disabled: currentPage === 1
    };
}
function getFirstPageItem(nearbyPages) {
    var _Math;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    if (firstNearbyPage === 1) {
        return null;
    }
    return {
        type: "first",
        pageNumber: 1,
        indicateOmittedPages: firstNearbyPage > 2 ? "after" : undefined
    };
}
function getNearbyPages(currentPage, totalPages) {
    var from = Math.max(1, Math.min(totalPages - 4, currentPage - 2));
    var to = Math.min(totalPages, Math.max(5, currentPage + 2));
    var pages = [];
    for(var i = from; i <= to; i += 1){
        var page = {
            type: "nearby-page",
            pageNumber: i,
            isCurrent: currentPage === i
        };
        if ([
            from,
            to
        ].includes(i) && !page.isCurrent) {
            page.omitOnSmallDevices = true;
        }
        pages.push(page);
    }
    return pages;
}
var getMidrangePage = function(position, nearbyPages, totalPages) {
    var _Math, _Math1;
    var threshold = 5;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    var lastNearByPage = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(nearbyPages));
    switch(position){
        case "before":
            if (firstNearbyPage < threshold) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.ceil(firstNearbyPage / 2),
                indicateOmittedPages: "after"
            };
        case "after":
            if (lastNearByPage + threshold > totalPages) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.floor((totalPages - lastNearByPage) / 2) + lastNearByPage,
                indicateOmittedPages: "before"
            };
        default:
            return null;
    }
};
function getLastPageItem(nearbyPages, totalPages) {
    var _Math;
    var lastNearbyPage = (_Math = Math).max.apply(_Math, _toConsumableArray(nearbyPages));
    if (lastNearbyPage === totalPages) {
        return null;
    }
    return {
        type: "last",
        pageNumber: totalPages,
        indicateOmittedPages: lastNearbyPage < totalPages - 1 ? "before" : undefined
    };
}
function getNextPageItem(currentPage, totalPages, alwaysShowStepButtons) {
    if (currentPage === totalPages && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "next",
        pageNumber: currentPage + 1,
        disabled: currentPage === totalPages
    };
}
function getPaginationItems(currentPage, totalPages) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _alwaysShowStepButtons = ref.alwaysShowStepButtons, alwaysShowStepButtons = _alwaysShowStepButtons === void 0 ? false : _alwaysShowStepButtons;
    if (totalPages <= 1) {
        return [];
    }
    var clampedCurrentPage = Math.max(1, Math.min(totalPages, currentPage));
    var nearbyPages = getNearbyPages(clampedCurrentPage, totalPages);
    var nearbyPageNrs = nearbyPages.map(function(page) {
        return page.pageNumber;
    });
    return [
        getPrevPageItem(clampedCurrentPage, alwaysShowStepButtons),
        getFirstPageItem(nearbyPageNrs),
        getMidrangePage("before", nearbyPageNrs, totalPages)
    ].concat(_toConsumableArray(nearbyPages), [
        getMidrangePage("after", nearbyPageNrs, totalPages),
        getLastPageItem(nearbyPageNrs, totalPages),
        getNextPageItem(clampedCurrentPage, totalPages, alwaysShowStepButtons)
    ]).filter(notNull);
}

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/number-pagination/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    ",
        "\n\n    @media screen and (max-width: 420px) {\n      ",
        "\n\n      @media screen and (max-width: 350px) {\n        margin: 0 ",
        " 0 0;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  font-weight: 600;\n  height: 30px;\n  justify-content: center;\n  min-width: 30px;\n  padding: ",
        ";\n  transition: all ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  box-shadow: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background: ",
        ";\n  color: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var measurements = base/* layout.measurements */.bK.measurements, animations = base/* layout.animations */.bK.animations;
var Pagination = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Pagination",
    componentId: "sc-0-0"
})(_templateObject());
var PaginationListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PaginationListItem",
    componentId: "sc-0-1"
})(function(param) {
    var indicateOmittedPages = param.indicateOmittedPages, omitOnSmallDevices = param.omitOnSmallDevices;
    return (0,styled_components_browser_esm.css)(_templateObject2(), indicateOmittedPages === "before" ? measurements.spacing150 : 0, indicateOmittedPages === "after" ? measurements.spacing150 : measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), indicateOmittedPages === "before" ? measurements.spacing050 : 0, indicateOmittedPages === "after" ? measurements.spacing050 : measurements.spacing025), omitOnSmallDevices ? "display: none;" : "", measurements.spacing025);
});
var paginationLinkStyles = (0,styled_components_browser_esm.css)(_templateObject4(), measurements.spacing050, animations.buttonTransition, base/* media.smallOnly */.BC.smallOnly(_templateObject3(), measurements.spacing025));
var PaginationLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "PaginationLink",
    componentId: "sc-0-2"
})(_templateObject5(), paginationLinkStyles, function(props) {
    return props.theme.colors.base800;
}, function(props) {
    return props.theme.colors.base200;
}, function(props) {
    return "transparent 0px 0px ".concat(props.theme.colors.base800, " 0px 0px 0px 1px");
});
var DisabledPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DisabledPaginationLink",
    componentId: "sc-0-3"
})(_templateObject6(), paginationLinkStyles, function(props) {
    return "inset 0 0 0 1px ".concat(props.theme.lines.primary);
}, function(props) {
    return props.theme.text.quaternary;
}, function(props) {
    return props.theme.bg.secondary;
});
var CurrentPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPaginationLink",
    componentId: "sc-0-4"
})(_templateObject7(), paginationLinkStyles, function(props) {
    return props.theme.colors.maybeBlue500;
}, function(props) {
    return props.theme.colors.base0;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-item.tsx





var PaginationItem = function(param) {
    var item = param.item, linkToPage = param.linkToPage, onClick = param.onClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var label = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null);
            case "next":
                return /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null);
            default:
                return /*#__PURE__*/ react.createElement(react.Fragment, null, item.pageNumber);
        }
    }, [
        item.type,
        item.pageNumber
    ]);
    var ariaLabel = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return t("symbols", "symbol.show-prev");
            case "next":
                return t("symbols", "symbol.show-next");
            default:
                return t("common", "pagination.page-number", {
                    number: item.pageNumber
                });
        }
    }, [
        item.type,
        item.pageNumber,
        t
    ]);
    var onClickHandler = (0,react.useCallback)(function() {
        return typeof onClick === "function" && onClick(item);
    }, [
        item,
        onClick
    ]);
    if (item.disabled) {
        return /*#__PURE__*/ react.createElement(DisabledPaginationLink, null, label);
    }
    if (item.isCurrent) {
        return /*#__PURE__*/ react.createElement(CurrentPaginationLink, {
            "data-test": "CurrentPaginationLink"
        }, label);
    }
    return /*#__PURE__*/ react.createElement(PaginationLink, {
        to: linkToPage(item.pageNumber),
        "data-test": "PaginationLink",
        "data-test-page": item.pageNumber,
        onClick: onClickHandler,
        "aria-label": ariaLabel
    }, label);
};
/* harmony default export */ var pagination_item = (PaginationItem);

;// CONCATENATED MODULE: ./src/components/number-pagination/index.tsx




var NumberPagination = function(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, linkToPage = param.linkToPage, onClick = param.onClick, alwaysShowStepButtons = param.alwaysShowStepButtons;
    var paginationItems = (0,react.useMemo)(function() {
        return getPaginationItems(currentPage, totalPages, {
            alwaysShowStepButtons: alwaysShowStepButtons
        });
    }, [
        currentPage,
        totalPages,
        alwaysShowStepButtons
    ]);
    return /*#__PURE__*/ react.createElement(Pagination, {
        "data-test": "Pagination"
    }, paginationItems.map(function(item) {
        return /*#__PURE__*/ react.createElement(PaginationListItem, {
            key: "".concat(item.type, ":").concat(item.pageNumber),
            indicateOmittedPages: item.indicateOmittedPages,
            omitOnSmallDevices: item.omitOnSmallDevices
        }, /*#__PURE__*/ react.createElement(pagination_item, {
            item: item,
            linkToPage: linkToPage,
            onClick: onClick
        }));
    }));
};


/***/ }),

/***/ 53692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": () => (/* reexport */ SIZE),
  "WX": () => (/* binding */ ProductCheckbox),
  "lo": () => (/* reexport */ hoverStyle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check/index.js
var check = __webpack_require__(24300);
;// CONCATENATED MODULE: ./src/components/product-checkbox/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-shadow: inset 0 0 0 2px ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  align-self: center;\n  background: ",
        ";\n  box-shadow: inset 0 0 0 1px ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n  cursor: pointer;\n  height: ",
        "px;\n  width: ",
        "px;\n  flex: 0 0 auto;\n  transition:\n    0.05s box-shadow linear,\n    0.05s background-color linear;\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SIZE = 20;
var hoverStyle = (0,styled_components_browser_esm.css)(_templateObject(), function(props) {
    return props.theme.bg.productCompare;
});
var Wrapper = styled_components_browser_esm["default"].label.attrs({
    "data-test": "ProductCheckbox"
}).withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.selected ? props.theme.bg.productCompare : "transparent";
}, function(props) {
    return props.theme.bg.productCompare;
}, function(props) {
    return props.theme.colors.base0;
}, SIZE, SIZE, hoverStyle);
var Input = styled_components_browser_esm["default"].input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(_templateObject2());
var Icon = (0,styled_components_browser_esm["default"])(check/* IconCheck */.N).attrs({
    size: SIZE
}).withConfig({
    displayName: "Icon",
    componentId: "sc-0-2"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/product-checkbox/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ProductCheckbox = function(_param) {
    var selected = _param.selected, name = _param.name, onSelect = _param.onSelect, onDeselect = _param.onDeselect, wrapperProps = _objectWithoutProperties(_param, [
        "selected",
        "name",
        "onSelect",
        "onDeselect"
    ]);
    var onChange = (0,react.useCallback)(function(e) {
        return e.target.checked ? onSelect === null || onSelect === void 0 ? void 0 : onSelect() : onDeselect === null || onDeselect === void 0 ? void 0 : onDeselect();
    }, [
        onSelect,
        onDeselect
    ]);
    return /*#__PURE__*/ react.createElement(Wrapper, _extends({
        selected: selected
    }, wrapperProps), /*#__PURE__*/ react.createElement(Input, {
        id: name,
        name: name,
        type: "checkbox",
        checked: selected,
        onChange: onChange,
        tabIndex: 0,
        value: selected ? "1" : "0"
    }), selected && /*#__PURE__*/ react.createElement(Icon, null));
};


/***/ }),

/***/ 24562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_row)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/product-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 5px 10px;\n  outline: none;\n\n  :hover::after,\n  :focus::after {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        padding-left: ",
        "px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  line-height: 1.2em;\n  min-height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .pj-ui-product-core-properties {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 100%;\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :not(:last-child) {\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  margin-left: 10px;\n  white-space: nowrap;\n  text-align: right;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 80px;\n  margin: ",
        ";\n  display: flex;\n  justify-content: end;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: -",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(_templateObject(), base/* styledUtils.overlay */.au.overlay());
var Row = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductRow"
}).withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.showDivider && (0,styled_components_browser_esm.css)(_templateObject1(), function(p) {
        return p.theme.lines.primary;
    });
}, function(props) {
    return props.selectable && (0,styled_components_browser_esm.css)(_templateObject2(), ProductLink, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr + (0,base/* pixelCalc */.A)(base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), ProductLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
});
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-3"
})(_templateObject6());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-4"
})(_templateObject7());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.theme.text.tertiary;
});
var PriceLabelWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-6"
})(_templateObject9());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-7"
})(_templateObject10(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var Gutter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-8"
})(_templateObject11());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-9"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Row, product_checkbox/* productCheckboxHoverStyle */.lo);
var CampaignBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CampaignBadgeWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-11"
})(_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(54497);
;// CONCATENATED MODULE: ./src/components/product-row/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ProductRow = function(param) {
    var onClick = param.onClick, linkAttributes = param.linkAttributes, _link = param.link, link = _link === void 0 ? "" : _link, image = param.image, name = param.name, rating = param.rating, subtitle = param.subtitle, campaignBadge = param.campaignBadge, ratingCount = param.ratingCount, _ratingCountTranslation = param.ratingCountTranslation, ratingCountTranslation = _ratingCountTranslation === void 0 ? {
        domain: "product",
        key: "product-card.n-ratings"
    } : _ratingCountTranslation, price = param.price, storesCount = param.storesCount, storesCountText = param.storesCountText, children = param.children, className = param.className, showDivider = param.showDivider, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        selectable,
        onToggle,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Row, {
        className: className,
        showDivider: showDivider,
        selectable: selectable,
        selected: selected
    }, /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes || {}, {
        to: link,
        "aria-label": name
    }), image && /*#__PURE__*/ react.createElement(ProductImage, null, image), /*#__PURE__*/ react.createElement(BasicInfo, null, /*#__PURE__*/ react.createElement(ProductName, null, name), rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true
    }) : null, subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadgeWrapper, null, /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge)), price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    }), storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: storesCountText
    }, /*#__PURE__*/ react.createElement("span", null, storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base500"
    })))), children && /*#__PURE__*/ react.createElement(Gutter, null, children), selectable && /*#__PURE__*/ react.createElement(SelectBox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
/* harmony default export */ var product_row = (ProductRow);


/***/ }),

/***/ 63536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* binding */ ProductsHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/products-header/components/header-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      display: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n\n  > a {\n    text-decoration: underline;\n    line-height: 1.4;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  margin-right: ",
        ";\n  margin-bottom: 0;\n  flex-grow: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: space-between;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    width: 100%;\n    grid-column-gap: ",
        ";\n    align-items: center;\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-column-gap: ",
        ";\n  align-items: center;\n  grid-auto-flow: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var TitleFlex = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleFlex",
    componentId: "sc-0-1"
})(_templateObject2(), base/* media.smallDown */.BC.smallDown(_templateObject1()));
var Title = (0,styled_components_browser_esm["default"])(variants.H3Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Subtitle = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-3"
})(_templateObject4());
var HeaderRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderRow",
    componentId: "sc-0-4"
})(function() {
    return (0,styled_components_browser_esm.css)(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject5()));
});
var DisplayOptions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DisplayOptions",
    componentId: "sc-0-5"
})(_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/search/components/sorted-by/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledTestsAndGuidesLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "StyledTestsAndGuidesLink",
    componentId: "sc-0-0"
})(styles_templateObject(), light_theme_colors.maybeBlue700);

// EXTERNAL MODULE: ./src/areas/search/types.ts
var types = __webpack_require__(78082);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/areas/search/components/hash-navigation.tsx





var TestsAndGuidesLink = function(param) {
    var count = param.count;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    (0,react.useEffect)(function() {
        var clearHashNavWithDelay = function() {
            if (location.hash === types/* TabAnchor.TESTS */.X.TESTS) {
                var searchQuery = location.search;
                setTimeout(function() {
                    history.replace("".concat(location.pathname).concat(searchQuery));
                }, 1000);
            }
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("hashchange", clearHashNavWithDelay);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("hashchange", clearHashNavWithDelay);
        };
    }, [
        location.hash,
        location.search,
        history
    ]);
    if (count <= 0) return null;
    return /*#__PURE__*/ react.createElement(StyledTestsAndGuidesLink, {
        href: types/* TabAnchor.TESTS */.X.TESTS,
        "data-test": "srp-expert-and-guide-button"
    }, "".concat(t("search", "search.buy-advice-guides"), " (").concat(count, ")"));
};

;// CONCATENATED MODULE: ./src/components/products-header/components/header-row/index.tsx



var header_row_HeaderRow = function(props) {
    var className = props.className, dataBotify = props.dataBotify, displayOptions = props.displayOptions, sortOptions = props.sortOptions, subtitle = props.subtitle, title = props.title, testsAndGuidesCount = props.testsAndGuidesCount;
    return /*#__PURE__*/ react.createElement(HeaderRow, {
        className: className,
        "data-test": "ProductsHeader"
    }, title || subtitle ? /*#__PURE__*/ react.createElement(TitleWrapper, {
        "data-test": "ProductsHeaderTitleWrapper"
    }, /*#__PURE__*/ react.createElement(TitleFlex, null, title && /*#__PURE__*/ react.createElement(Title, {
        "data-botify": dataBotify
    }, title), /*#__PURE__*/ react.createElement(TestsAndGuidesLink, {
        count: testsAndGuidesCount || 0
    })), subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)) : null, sortOptions !== null && sortOptions !== void 0 ? sortOptions : null, displayOptions ? /*#__PURE__*/ react.createElement(DisplayOptions, null, displayOptions) : null);
};

;// CONCATENATED MODULE: ./src/components/products-header/index.tsx


var ProductsHeader = function(props) {
    var children = props.children, className = props.className, dataBotify = props.dataBotify, displayOptions = props.displayOptions, sortOptions = props.sortOptions, subtitle = props.subtitle, title = props.title, testsAndGuidesCount = props.testsAndGuidesCount;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(header_row_HeaderRow, {
        className: className,
        "data-botify": dataBotify,
        displayOptions: displayOptions,
        sortOptions: sortOptions,
        subtitle: subtitle,
        title: title,
        testsAndGuidesCount: testsAndGuidesCount
    }), children);
};


/***/ }),

/***/ 22663:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tr": () => (/* binding */ Variants)
/* harmony export */ });
/* unused harmony export Colors */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2902);
/* harmony import */ var _prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1747);
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/control-has-associated-label */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var Variants;
(function(Variants) {
    Variants["rate"] = "rate";
    Variants["scale"] = "scale";
    Variants["boolean"] = "boolean";
    Variants[// Experimental new boolean presentation, similar to regular buttons
    "booleanV2"] = "booleanV2";
})(Variants || (Variants = {}));
var Colors;
(function(Colors) {
    Colors["negative"] = "negative";
    Colors["neutral"] = "neutral";
    Colors["positive"] = "positive";
})(Colors || (Colors = {}));
var ratingColorMap = [
    Colors.negative,
    Colors.negative,
    Colors.neutral,
    Colors.positive,
    Colors.positive
];
var MultiRadio = function(param) {
    var currentValue = param.currentValue, disabledOptions = param.disabledOptions, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, name = param.name, onClick = param.onClick, options = param.options, _optionValues = param.optionValues, optionValues = _optionValues === void 0 ? [] : _optionValues, required = param.required, _size = param.size, size = _size === void 0 ? "medium" : _size, variant = param.variant;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).t;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? optionValues[currentValue - 1] : undefined), 2), selected = ref[0], setSelected = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? ratingColorMap[currentValue - 1] : Colors.neutral), 2), ratingColor = ref1[0], setRatingColor = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), error = ref2[0], setError = ref2[1];
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue), 2), checked = ref3[0], setChecked = ref3[1];
    var getSize = function() {
        switch(size){
            case "small":
                return 20;
            case "medium":
            default:
                return 32;
        }
    };
    var iconSize = getSize();
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.target.checkValidity()) {
            setError(null);
        }
        setSelected(e.target.dataset.value);
        setChecked(parseInt(e.target.value, 10));
        if (variant === Variants.rate) {
            var index = Number(e.target.value) - 1;
            setRatingColor(ratingColorMap[index]);
        }
        if (onClick) onClick(e);
    }, [
        onClick,
        variant
    ]);
    var getIsDisabled = function(option) {
        return (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.length) ? (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.find(function(item) {
            return item === option;
        })) !== undefined : false;
    };
    var handleInvalidity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (error === e.target.name) return;
        setError(e.target.name);
    }, [
        error
    ]);
    if (variant === Variants.rate) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity
        }, options.map(function(option, index) {
            switch(option){
                case 1:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngryIcon */ .u7, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 2:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfiedIcon */ .fV, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 3:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutralIcon */ .cI, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 4:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmilingIcon */ .oX, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 5:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues.length ? optionValues[index] : undefined,
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughingIcon */ .mv, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                default:
                    return null;
            }
        }), selected && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .SelectedRating */ .u1, {
            color: ratingColor
        }, selected)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.scale) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            hasSelected: Boolean(optionValues.length),
            showError: error === name
        }, optionValues.length ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Selected */ .Ne, null, selected !== null && selected !== void 0 ? selected : t("reviews", "form.question-nothing-selected")) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, options.map(function(option, index) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                key: option
            }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ScaleRadio */ .az, {
                type: "radio",
                name: name,
                id: "".concat(name, ":").concat(option),
                value: option,
                "data-value": optionValues.length ? optionValues[index] : undefined,
                required: required,
                onChange: handleChange,
                alignRight: index + 1 === options.length,
                alignLeft: index === 0,
                showError: error === name,
                tabIndex: 0,
                checked: checked === option
            }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                htmlFor: "".concat(name, ":").concat(option),
                "data-label": labels.length ? labels[index] : null
            }));
        }))), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.boolean || variant === Variants.booleanV2) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            showError: error === name
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":1"),
            value: "1",
            "data-value": t("reviews", "form.boolean-yes"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 1,
            variant: variant
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":1")
        }, t("reviews", "form.boolean-yes")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":0"),
            value: "0",
            "data-value": t("reviews", "form.boolean-no"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 0,
            variant: variant
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":0")
        }, t("reviews", "form.boolean-no")), options.length > 2 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":2"),
            value: "2",
            "data-value": t("reviews", "form.boolean-unknown"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 2,
            variant: variant
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":2")
        }, t("reviews", "form.boolean-no"))) : null)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (MultiRadio);


/***/ }),

/***/ 2902:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N$": () => (/* binding */ RadioRating),
/* harmony export */   "Ne": () => (/* binding */ Selected),
/* harmony export */   "az": () => (/* binding */ ScaleRadio),
/* harmony export */   "cI": () => (/* binding */ EmoticonNeutralIcon),
/* harmony export */   "fV": () => (/* binding */ EmoticonDissatisfiedIcon),
/* harmony export */   "jj": () => (/* binding */ Error),
/* harmony export */   "kq": () => (/* binding */ Inputs),
/* harmony export */   "mv": () => (/* binding */ EmoticonLaughingIcon),
/* harmony export */   "ng": () => (/* binding */ MultiRadio),
/* harmony export */   "oX": () => (/* binding */ EmoticonSmilingIcon),
/* harmony export */   "qV": () => (/* binding */ BooleanRadio),
/* harmony export */   "u1": () => (/* binding */ SelectedRating),
/* harmony export */   "u7": () => (/* binding */ EmoticonAngryIcon),
/* harmony export */   "uZ": () => (/* binding */ RadioDot)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var src_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13686);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22663);
/* stylelint-disable */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  opacity: 0;\n  position: absolute;\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          height: ",
        ";\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n            top: ",
        "px;\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      position: relative;\n      height: ",
        ";\n      align-items: flex-start;\n      width: 100%;\n\n      ",
        ";\n\n      ",
        " {\n        width: 100%;\n        justify-content: space-between;\n\n        &::after {\n          content: '';\n          width: 100%;\n          position: absolute;\n          top: ",
        "px;\n          z-index: 1;\n          border-top: 1px solid\n            ",
        ";\n\n          ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      background: #eee;\n      padding: 2px;\n      border-radius: 4px;\n\n      box-shadow: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    border-radius: 20px;\n    background: ",
        ";\n    padding: 1px ",
        ";\n    color: ",
        ";\n    line-height: initial;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  height: 20px;\n  max-height: 20px;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  background: #eee;\n  border-radius: 5px;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n          margin-right: ",
        ";\n        "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      cursor: pointer;\n      line-height: 0;\n\n      &:not(:last-of-type) {\n        margin-right: ",
        ";\n\n        ",
        "\n      }\n    }\n\n    &:checked + label {\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n    }\n\n    &.focus-visible + label {\n      ",
        ",\n      ",
        ",\n    ",
        ",\n    ",
        ",\n    ",
        " {\n        box-shadow: 0 0 0 2px ",
        ";\n      }\n    }\n\n    &:disabled + label {\n      cursor: not-allowed;\n    }\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n          right: 0;\n          left: unset;\n          transform: translateX(0);\n          text-align: right;\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n          left: 0;\n          transform: translateX(0);\n          text-align: left;\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      z-index: 2;\n      border-radius: ",
        "px;\n      border: 1px solid\n        ",
        ";\n\n      ",
        ";\n\n      position: relative;\n\n      &::after {\n        content: attr(data-label);\n        position: absolute;\n        align-self: center;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-top: ",
        ";\n        color: ",
        ";\n        width: 100px;\n        font-size: ",
        ";\n        text-align: center;\n        white-space: nowrap;\n\n        ",
        ";\n\n        ",
        ";\n      }\n    }\n\n    &:checked + label > ",
        " {\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      border-radius: 50%;\n\n      ",
        ";\n    }\n\n    &.focus-visible + label {\n      border: 2px solid ",
        ";\n    }\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n            padding: ",
        " ",
        ";\n          "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        ";\n\n        & + label {\n          cursor: pointer;\n          padding: ",
        "\n            ",
        ";\n          border-radius: 5px;\n          white-space: nowrap;\n          user-select: none;\n\n          ",
        ";\n        }\n\n        &:checked + label {\n          background: #fff;\n        }\n\n        &.focus-visible + label {\n          box-shadow: 0 0 0 2px ",
        ";\n        }\n      "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        ";\n\n        & + label {\n          cursor: pointer;\n          margin-right: ",
        ";\n          padding: ",
        ";\n          min-width: 60px;\n          text-align: center;\n          border: 1px solid\n            ",
        ";\n          border-radius: 8px;\n          white-space: nowrap;\n          user-select: none;\n          background: #fff;\n        }\n\n        &:checked + label {\n          padding: calc(",
        " - 1px);\n          border-width: 2px;\n          border-color: ",
        ";\n        }\n      "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n  margin-top: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}




var CHECKBOX_SIZE = {
    DESKTOP: 18,
    MOBILE: 18
};
var disabledInputStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var Inputs = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Inputs",
    componentId: "sc-0-0"
})(_templateObject1());
var RadioDot = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "RadioDot",
    componentId: "sc-0-1"
})(_templateObject2());
var MultiRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MultiRadio",
    componentId: "sc-0-2"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.rate */ .tr.rate && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3()), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.scale */ .tr.scale && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), p.hasSelected ? "80px" : "60px", src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject4(), p.hasSelected ? "90px" : "70px"), Inputs, CHECKBOX_SIZE.DESKTOP / 2, p.showError ? p.theme.text.negative : p.theme.lines.tertiary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject5(), CHECKBOX_SIZE.MOBILE / 2)), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.boolean */ .tr.boolean && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : "none"), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.booleanV2 */ .tr.booleanV2 && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8()));
});
var SelectedRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SelectedRating",
    componentId: "sc-0-3"
})(function(param) {
    var color = param.color, theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, theme.ratings[color].bg, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, theme.ratings[color].fg);
});
var Selected = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Selected",
    componentId: "sc-0-4"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var iconStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12(), function(p) {
    return p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : 0;
});
var EmoticonAngryIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngry */ .Sd).withConfig({
    displayName: "EmoticonAngryIcon",
    componentId: "sc-0-5"
})(_templateObject13(), iconStyling);
var EmoticonDissatisfiedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfied */ ._z).withConfig({
    displayName: "EmoticonDissatisfiedIcon",
    componentId: "sc-0-6"
})(_templateObject14(), iconStyling);
var EmoticonNeutralIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutral */ .sS).withConfig({
    displayName: "EmoticonNeutralIcon",
    componentId: "sc-0-7"
})(_templateObject15(), iconStyling);
var EmoticonSmilingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmiling */ .wr).withConfig({
    displayName: "EmoticonSmilingIcon",
    componentId: "sc-0-8"
})(_templateObject16(), iconStyling);
var EmoticonLaughingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughing */ .X3).withConfig({
    displayName: "EmoticonLaughingIcon",
    componentId: "sc-0-9"
})(_templateObject17(), iconStyling);
var RadioRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "RadioRating",
    componentId: "sc-0-10"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, props.$size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), EmoticonAngryIcon, props.theme.ratings.negative.bg, EmoticonDissatisfiedIcon, props.theme.ratings.negative.bg, EmoticonNeutralIcon, props.theme.ratings.neutral.bg, EmoticonSmilingIcon, props.theme.ratings.positive.bg, EmoticonLaughingIcon, props.theme.ratings.positive.bg, EmoticonAngryIcon, EmoticonDissatisfiedIcon, EmoticonNeutralIcon, EmoticonSmilingIcon, EmoticonLaughingIcon, props.theme.icons.callToAction);
});
var ScaleRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "ScaleRadio",
    componentId: "sc-0-11"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject24(), disabledInputStyles, CHECKBOX_SIZE.DESKTOP, CHECKBOX_SIZE.DESKTOP, p.theme.bg.primary, CHECKBOX_SIZE.DESKTOP, p.showError ? p.theme.text.negative : p.theme.lines.quaternary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject20(), CHECKBOX_SIZE.MOBILE, CHECKBOX_SIZE.MOBILE), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.secondary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, p.alignRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject21()), p.alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject22()), RadioDot, CHECKBOX_SIZE.DESKTOP - 6, CHECKBOX_SIZE.DESKTOP - 6, p.theme.lines.highlight, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject23(), CHECKBOX_SIZE.MOBILE - 6, CHECKBOX_SIZE.MOBILE - 6), p.theme.icons.callToAction);
});
var BooleanRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "BooleanRadio",
    componentId: "sc-0-12"
})(function(p) {
    return p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.boolean */ .tr.boolean ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject26(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject25(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150), p.theme.icons.callToAction) : (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject27(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.colors.base800, "0.12"), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, p.theme.colors.maybeBlue500);
});
var Error = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Error",
    componentId: "sc-0-13"
})(_templateObject28(), function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100 : 0;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.negative;
}, function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.text.negative, "0.1") : "none";
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 38794:
/***/ ((module) => {

module.exports = "query dealsQuery($page: Int! = 0, $sortType: SearchV3Sorting!, $filters: [SearchFilter!]!) {\n  searchV3 {\n    products(\n      sortType: $sortType\n      page: $page\n      filters: $filters\n      order: desc\n      searchType: deals\n    ) {\n      items {\n        ... on ProductCard {\n          productId\n          priceDrop\n          coreProperties\n          dealUpdateTime\n          logo\n          name\n          aggregatedRating {\n            score\n            count\n          }\n          productLink\n          storeCount\n          categoryName\n          bestOffer {\n            storeId\n            stockStatus\n            shopOfferId\n            storeName\n            originalPrice\n            memberPrice\n            price\n            offerLink\n            featured\n            priceExpires\n            membershipRequiresCompensation\n          }\n          __typename\n        }\n      }\n      availabilityAggregations {\n        key\n        count\n        name\n      }\n      leafCategories {\n        key\n        count\n        name\n        logo\n      }\n      categoryAggregations {\n        key\n        parentKey\n        count\n        name\n        logo\n      }\n      brandsAggregations {\n        key\n        count\n        name\n      }\n      priceHistogram {\n        min\n        max\n        count\n      }\n      ratingHistogram {\n        key\n        count\n      }\n      shopAggregations {\n        key\n        count\n        name\n      }\n      hasMorePages\n      didYouMean\n      numberOfHits\n    }\n  }\n}"

/***/ }),

/***/ 40877:
/***/ ((module) => {

module.exports = "query EntitySearchComponent($query: String!, $stores: Boolean!, $products: Boolean!) {\n  newSearch(query: $query) {\n    query\n    results {\n      products(limit: 5) @skip(if: $stores) {\n        nodes {\n          ... on Product {\n            __typename\n            id\n            name\n            pathName\n            userReviewSummary {\n              rating\n              count\n            }\n            aggregatedRating {\n              score\n              count\n            }\n            priceSummary {\n              regular\n              alternative\n              count\n            }\n            media {\n              first(width: _280)\n            }\n            category {\n              name\n            }\n          }\n        }\n      }\n      shops(limit: 5) @skip(if: $products) {\n        nodes {\n          __typename\n          id\n          name\n          pathName\n          hasLogo\n          logo(width: _88)\n        }\n      }\n    }\n  }\n}"

/***/ })

}]);